import {
    UpdateShouldShowSimplifiedBDUIAction,
    updateShouldShowSimplifiedBdUISuccess,
    UpdateUserDevicesAction,
    updateUserDevicesSuccess,
    VerifyCommsUserAction,
    verifyCommsUserSuccess,
} from './../actions/user';
import {
    archiveBuildDistributionBucketSuccess,
    ArchiveBuildDistributionBucketSuccessResponse,
    FetchBuildDistributionBucketBuildResponsePayload,
    fetchBuildDistributionBucketBuildSuccess,
    newBuildDistributionBucketSuccess,
    NewBuildDistributionBucketSuccessResponse,
    ShareBuildDistributionBuildWithTestersAction,
    shareBuildDistributionBuildWithTestersSuccess,
    ShareBuildDistributionBuildWithTestersSuccessResponse,
    TRIGGER_BUILD_DISTRIBUTION_BUILD,
    TriggerBuildDistributionBuildAction,
    TRY_ARCHIVE_BUILD_DISTRIBUTION_BUCKET,
    TRY_NEW_BUILD_DISTRIBUTION_BUCKET,
    TryArchiveBuildDistributionBucketAction,
    TryUpdateBuildDistributionBucketAction,
    UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES,
    UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS,
    UpdateBuildDistributionBucketSuccessResponse,
    UpdateBuildDistributionBuildTesterNotesAction,
    updateBuildDistributionBuildTesterNotesSuccess,
    UpdateBuildDistributionBuildTesterNotesSuccessResponse,
    updateDistributionBucketsSuccess,
    updateDistributionBucketSuccess,
    ArchiveBuildDistributionBuildAction,
    archiveBuildDistributionBuildSuccess,
    ArchiveBuildDistributionBuildSuccessResponse,
    ARCHIVE_BUILD_DISTRIBUTION_BUILD,
} from './../actions/buildDistribution';
import {
    FetchFeatureFlagsResponse,
    TryUpdateFeatureFlagsAction,
    updateFeatureFlagsForReleases,
    updateFeatureFlagsSuccess,
} from './../actions/featureFlags';
import * as Analytics from '../utils/analytics';
import { AppProperties } from '../utils/analytics';
import { getCurrentThemeMode } from '../components/styles/themeMode';
import {
    AuthCredentials,
    BuildDistroBucketBase,
    BuildDistroBuild,
    FeatureFlag,
    GetAllDevicesResponse,
    NonErrorRunwayResponseTypes,
    ReleaseStep,
    RolloutMonitoring,
    RunwayModelsResponse,
    RunwayResponseType,
    RunwayResponseV2,
} from './../types';
import { all, delay, put, select, spawn, takeEvery, takeLatest, takeLeading } from 'redux-saga/effects';
import {
    logoutSuccess,
    TRY_LOGIN,
    TRY_LOGOUT,
    TRY_VERIFY_AUTH_CODE,
    TryLoginAction,
    TryLogoutAction,
    TryVerifyAuthCodeAction,
} from '../actions/login';
import * as Sentry from '@sentry/react';
import {
    AllStateUpdateEventModelTypes,
    App,
    AppGroup,
    AppSettings,
    DashboardState,
    Environment,
    ModelType,
    Notification,
    OrganizationEntity,
    Release,
    ReleaseStepType,
    User,
    ClientScriptsConfig,
    WebsocketEventContainer,
    WebsocketMessageType,
    WebsocketNewStateEvent,
    WebsocketNotificationEvent,
    WebsocketStateUpdateEvent,
    IssueEntity,
} from '../types';
import * as API from '../api';
import { RunwayResponseError } from '../api';
import {
    AddAppsAction,
    appEntityUpdated,
    APPS_ADDED_SUCCESS,
    appsAddedSuccess,
    appsDeleted,
    appsUpdated,
    ConnectedAppEntityResponse,
    CreateAppAction,
    DeletedAppEntityPayload,
    TRY_ADD_APPS,
    TRY_CREATE_APP,
    TRY_DELETE_APP_ENTITY,
    TryDeleteAppAction,
    TrySetAutomationPauseAction,
    setAutomationPauseSuccess,
} from '../actions/app';
import {
    ConnectedReleaseResponse,
    deleteReleaseEntity,
    DeleteReleaseEntityPayload,
    deleteReleasesTriggeredFromWebsocket,
    NEW_RELEASE_SUCCESS,
    newReleaseSuccessAction,
    releasesUpdated,
    TRIGGER_RELEASE_WORKFLOW_BUILD,
    TriggerReleaseWorkflowBuildAction,
    TRY_DELETE_RELEASE_ENTITY,
    TRY_NEW_RELEASE,
    TRY_UPDATE_RELEASE_ENTITY,
    TryDeleteReleaseAction,
    TryNewReleaseAction,
    TryUpdateReleaseAction,
    TryUpdateReleaseEntityAction,
    updateReleaseEntitySuccess,
    UpdateReleaseResponse,
    updateReleaseSuccess,
} from '../actions/release';
import { loadingActionStart, loadingStopAction } from '../actions/loading';
import {
    AllAppSettingsUpdatableTypes,
    AllAppSettingsV2UpdatableTypes,
    AllAppUpdatableTypes,
    AllAuthUpdatableTypes,
    AllBuildDistroUpdatableTypes,
    AllChecklistItemUpdatableTypes,
    AllDevicesUpdatableTypes,
    AllFeatureFlagUpdatableTypes,
    AllIntegrationDeletableTypes,
    AllIntegrationRefreshableTypes,
    AllIntegrationUpdatableTypes,
    AllOrgSettingsUpdatableTypes,
    AllPublicApiUpdatableTypes,
    AllReleaseStepUpdatableTypes,
    AllReleaseUpdatableTypes,
    BuildDistributionUpdatable,
    OrgSettingsUpdatable,
    ReleaseStepUpdatable,
    ReleaseUpdatable,
    Updatable,
    UserUpdatable,
} from '../actions/updatable';
import { updatedStartAction, updatedStopAction, willUpdateStartAction, willUpdateStopAction } from '../actions/updated';
import {
    TRY_REFRESH_INTEGRATIONS,
    TryRefreshIntegrationsAction,
    TryUpdateAppSettingsAction,
    TryUpdateAppSettingsV2Action,
    updateAppSettingsSuccessAction,
} from '../actions/appSettings';
import {
    CREATE_INTEGRATION_REQUEST_SUCCESS,
    CreateDeleteIntegrationResponse,
    createIntegrationSuccess,
    DeleteIntegrationAction,
    deleteIntegrationSuccess,
    refreshIntegrationSuccess,
    TRY_UPDATE_INTEGRATION_ALIAS,
    TryCreateIntegrationAction,
    TryRefreshIntegrationAction,
    TryUpdateIntegrationAction,
    TryUpdateIntegrationAliasAction,
    updateIntegrationsSuccess,
    updateIntegrationSuccess,
} from '../actions/integrations';
import { clearFailure, requestFailedAction } from '../actions/failed';
import { newNotification } from '../actions/notifications';
import { orgStateUpdated } from '../actions/organization';
import { newPasswordSuccess, TryNewPasswordAction, TrySignUpAction } from '../actions/user';
import { dashboardStateUpdatedFromWebsocket } from '../actions/dashboardState';
import * as GoogleAnalytics from '../utils/ga';
import userflow from 'userflow.js';
import * as HubspotUtils from '../utils/hubspot';
import {
    appSettingsApiRequestForAppUpdateType,
    appSettingsV2ApiRequestForAppUpdateType,
    fetchEntityRequestForEntityType,
    fetchEntityRequestForEntityTypeV2,
    fetchEntityUpdateAction,
    fetchPaginatedEntitiesRequestForEntityType,
    fetchPaginatedEntitiesUpdateAction,
    fetchPaginatedEntitiesUpdatePaginationDataAction,
    orgSettingsApiRequestForOrgUpdateType,
    runwayModelsFromFetchEntityResponse,
    updatableRequestForUpdatable,
    updateApiForChecklistItemUpdatable,
    updateBuildDistributionBucketRequestForAction,
    updateDevicesRequestForAction,
    updateFeatureFlagsRequestForFeatureFlagUpdatable,
    updateReleaseApiRequestForReleaseUpdatable,
    updateReleaseStepApiRequestForReleaseStepUpdatableType,
} from '../helpers/apiHelpers';
import {
    authSuccess,
    clearAuth,
    redirectAuthNeeded,
    TRY_REFRESH_AUTH_TOKEN,
    TRY_SILENT_REFRESH_TOKEN,
    TryRefreshAuthTokenAction,
    updateTwoFactorAuthRequired,
} from '../actions/auth';
import {
    selectAllAppGroupNamesInOrg,
    selectAllAppsIdsInOrg,
    selectApp,
    selectAppCount,
    selectAuthCredentials,
    selectBuildDistributionBucketById,
    selectCanEnableMergeAccountsSetting,
    selectDemoIssuesForApp,
    selectDemoIssueTimeline,
    selectIsAppsDemoModeEnabled,
    selectIsAppStateFetchedForApps,
    selectIsDemoInstance,
    selectIsDemoModeEnabledForRelease,
    selectMergeAccountsEnabled,
    selectOrg,
    selectRelease,
    selectReleaseCount,
    selectStepConfig,
    selectTriageFilters,
    selectUser,
    selectUserflowIdentitySignature,
    selectUserIsAdmin,
} from '../selectors/selectors';
import {
    BucketMemberEntityRequest,
    CommonSagaActionsData,
    tryFetchPaginatedEntities,
    TryFetchEntityAction,
    TryFetchEntityActionV2,
    TryFetchPaginatedEntitiesAction,
    UpdateBuildDistroBucketAutomationSettingsRequest,
    UpdateBuildDistroBucketNotificationSettingsRequest,
} from '../actions/entities';
import {
    fetchIssueTimelineSuccess,
    issueFetched,
    issueUpdated,
    IssuesRequest,
    pinCreatedIssue,
    TRY_ADD_ISSUE_SOURCES,
    TRY_CREATE_ISSUE,
    TRY_FETCH_ISSUE,
    TRY_FETCH_ISSUE_TIMELINE,
    TRY_BULK_TRANSITION_ISSUES,
    TRY_BULK_REOPEN_ISSUES,
    TRY_GROUP_ISSUES,
    TRY_REOPEN_ISSUE,
    TRY_REQUEST_ISSUE_FIX,
    TRY_MARK_ISSUES_AS_RELATED,
    TRY_TRANSITION_ISSUE,
    TRY_UNMARK_ISSUE_AS_RELATED,
    TRY_UPDATE_ISSUE,
    TRY_UNMERGE_ISSUE_SOURCES,
    TRY_UPDATE_ISSUE_ASSIGNEES,
    TRY_UPDATE_ISSUE_FIX_REQUEST,
    TryAddIssueSourcesAction,
    TryCreateIssueAction,
    TryFetchIssueAction,
    TryFetchIssueTimelineAction,
    TryBulkTransitionIssuesAction,
    TryBulkReopenIssuesAction,
    TryGroupIssuesAction,
    TryReopenIssueAction,
    TryRequestIssueFixAction,
    TryMarkIssuesAsRelatedAction,
    TryTransitionIssueAction,
    TryUnmergeIssueSourcesAction,
    TryUnmarkIssueAsRelatedAction,
    TryUpdateIssueAction,
    TryUpdateIssueAssigneesAction,
    TryUpdateIssueFixRequestAction,
} from '../actions/triage';
import {
    AppSettingsV2APIResponse,
    AuthResponse,
    ChecklistItemUpdatableAPIResponse,
    ConfigResponse,
    CreateAppApiResponse,
} from '../apiResponseTypes';
import {
    appGroupsDeleted,
    appGroupsUpdated,
    ConnectedAppGroupEntityResponse,
    DeletedAppGroupPayload,
} from '../actions/appGroups';
import { flatten, flattenDeep, isEqual } from 'lodash';
import { getDemoIssuesResponse } from '../testData/issues';
import { FetchableEntityType, FetchableEntityTypeV2, FetchablePaginatedEntityType } from '../entityType';
import * as WsEffects from './wsSagas';
import * as Storage from '../helpers/localStorageHelper';
import {
    clearState,
    fetchStateSuccess,
    TRY_CHANGE_ORG_FETCH_STATE,
    TRY_FETCH_STATE,
    TryChangeOrgFetchStateAction,
    TryFetchStateAction,
} from '../actions/state';
import {
    SetDefaultGroupsDisabledResponse,
    TryUpdateOrgSettingsAction,
    UPDATE_ORG_SETTINGS_SUCCESS,
    updateOrgSettingsSuccessAction,
} from '../actions/orgSettings';
import { tryWebsocketConnect, tryWebsocketDisconnect } from '../actions/ws';
import {
    getAppConfigSuccess,
    TRY_GET_APP_CONFIG,
    TRY_SILENT_GET_APP_CONFIG,
    TryUpdateAppConfigAction,
} from '../actions/appConfig';

import {
    TRACK_APP_ROUTE_EVENT,
    TRACK_BUILD_DISTRO_EVENT,
    TRACK_ONBOARDING_EVENT,
    TRACK_ORG_ROUTE_EVENT,
    TRACK_RELEASE_ROUTE_EVENT,
    TRACK_RELEASE_STEP_VIEW_EVENT,
    TRACK_STEP_CONFIG_EVENT,
    TRACK_USER_EVENT,
    TrackAppRouteEventAction,
    TrackBuildDistroViewEventAction as TrackBuildDistroEventAction,
    TrackOnboardingEventAction,
    TrackOrgRouteEventAction,
    TrackReleaseRouteEventAction,
    TrackReleaseStepViewEventAction,
    TrackStepConfigEventAction,
    TrackUserEventAction,
} from '../actions/trackEvent';
import { allBuildDistroPropertiesFrom, allReleasePropertiesFrom } from '../helpers/trackingHelpers';
import {
    CreateApiKeyData,
    createPublicApiKey,
    CreatePublicApiKeyResponse,
    TryAddPublicApiKeyAction,
} from '../actions/publicApi';
import { RolloutMonitoringResponse, updateRolloutMonitoringForReleases } from '../actions/rolloutMonitoring';
import {
    TRY_FETCH_IOS_DEPENDENCIES_FOR_RELEASE,
    TryFetchIosDependenciesForReleaseAction,
    fetchIosDependenciesForReleaseSuccess,
    updateIosDependenciesReportForRelease,
} from '../actions/iosDependencies';
import { IosDependenciesReleaseReport } from '../types/iosDependencies';
import { GA_MEASUREMENT_ID, STAPE_ID_COOKIE_KEY } from '../constants';
import { initializeClientScripts } from '../utils/scriptManager';
import { appsAddedShouldRedirect, updatePaginationDataAction } from '../actions/ui';
import { TryNewBuildDistributionBucketAction } from '../actions/buildDistribution';
import { globalMessage } from '../utils/globalMessage';
import { TryUpdateDevicesAction, updateDevicesSuccess } from '../actions/devices';

import * as InternalFeatureFlags from '../utils/internalFeatureFlags';
import { UPDATE_FEATURE_ITEMS_SORT, UpdateFeatureItemsSortAction } from '@/actions/sorts';
import {
    REMOVE_FEATURE_ITEMS_FILTER,
    RemoveFeatureItemsFilterAction,
    UPDATE_FEATURE_ITEMS_FILTERS,
    UPDATE_GROUP_WORK_ITEMS_BY_TICKET,
    UPDATE_SHOW_FIXES_ONLY,
    UpdateFeatureItemsFiltersAction,
    UpdateGroupWorkItemsByTicketAction,
    UpdateShowFixesOnlyAction,
} from '@/actions/filters';
import { AnyFilter } from '@/types/filters';
import { SortType } from '@/types/sorts';
import { selectAppliedFilters } from '@/selectors/memoizedSelectors';
import {
    deleteChecklistItemTemplates,
    TryUpdateChecklistItemAction,
    updateChecklistItemTemplates,
} from '@/actions/checklistItems';
import { TryUpdateReleaseStepAction, updateReleaseSteps } from '@/actions/releaseStep';
import { call } from 'typed-redux-saga';
import { updateStepRuns } from '@/actions/stepRun';
import { stepRunsSummaryActions } from '@/reducers/stepRunsSummary';
import { AllRunwayUpdatables, hasSupportForParallelism, TryUpdatableAction } from '@/actions/common';
import { updateStepConfigs } from '@/actions/stepConfig';
import { StepRun } from '@/types/stepRun';
import { updateAutomations } from '@/actions/automations';
import { updateWorkflowRunStepRunGraphs } from '@/actions/workflowRunStepRunGraph';
import { updateWorkflowOverview, updateWorkflowStepGraphs } from '@/actions/workflow';
import { isTokenRefreshDue } from '@/utils/tokenExpiry';
import { getAppUsesWorkflows } from '@/helpers';
import { updateOrgChecklistItemTemplates } from '@/actions/orgChecklistItemTemplates';
import { updateOrgUsersVCSUserData } from '@/actions/orgUsersVCSUserData';
import { invalidateAppHomeCache, invalidateWorkflowOverviewCache } from '@/middlewares/defaultApi';

function* trackOrgRouteEventSaga(action: TrackOrgRouteEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const baseProperties = allReleasePropertiesFrom(
        org,
        undefined,
        undefined,
        appIdsInOrg,
        appGroupNamesInOrg,
        undefined,
        undefined,
    );

    const allProperties = {
        ...baseProperties,
        ...(action.payload.viewType ? { viewType: action.payload.viewType } : {}),
        ...(action.payload.page ? { page: action.payload.page } : {}),
    };

    yield* call(Analytics.track, action.payload.eventName, allProperties);
}

function* trackAppRouteEventSaga(action: TrackAppRouteEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);

    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const baseProperties = allReleasePropertiesFrom(
        org,
        app,
        undefined,
        appIdsInOrg,
        appGroupNamesInOrg,
        undefined,
        undefined,
    );

    const allProperties = {
        ...baseProperties,
        ...(action.payload.viewType ? { viewType: action.payload.viewType } : {}),
        ...(action.payload.page ? { page: action.payload.page } : {}),
    };

    yield* call(Analytics.track, action.payload.eventName, allProperties);
}

function* trackReleaseRouteEventSaga(action: TrackReleaseRouteEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const release = yield select(selectRelease, action.payload.releaseId);
    const user = yield select(selectUser);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const baseProperties = allReleasePropertiesFrom(
        org,
        app,
        release,
        appIdsInOrg,
        appGroupNamesInOrg,
        action.payload.context,
    );
    const userProps = Analytics.userProperties(user) ?? {};

    const allProperties = {
        ...baseProperties,
        ...userProps,
        ...(action.payload.chartName && { chartName: action.payload.chartName }),
        ...(action.payload.stepArchetype && { stepArchetype: action.payload.stepArchetype }),
    };

    yield* call(Analytics.track, action.payload.eventName, allProperties);
}

function* trackViewReleaseStepEventSaga(action: TrackReleaseStepViewEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const release = yield select(selectRelease, action.payload.releaseId);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const allProperties = allReleasePropertiesFrom(org, app, release, appIdsInOrg, appGroupNamesInOrg);

    let eventName: Analytics.Event | null = null;

    switch (action.payload.releaseStepType) {
        case ReleaseStepType.Kickoff:
            eventName = Analytics.Event.ViewKickoff;
            break;
        case ReleaseStepType.FeatureReadiness: {
            eventName = Analytics.Event.ViewFeatureReadiness;
            break;
        }
        case ReleaseStepType.ReleaseCandidate:
            eventName = Analytics.Event.ViewReleaseCandidate;
            break;
        case ReleaseStepType.RegressionTesting:
            eventName = Analytics.Event.ViewRegressionTesting;
            break;
        case ReleaseStepType.BetaTesting:
            eventName = Analytics.Event.ViewBetaTesting;
            break;
        case ReleaseStepType.Metadata:
            eventName = Analytics.Event.ViewMetadata;
            break;
        case ReleaseStepType.Screenshots:
            eventName = Analytics.Event.ViewScreenshots;
            break;
        case ReleaseStepType.Approvals:
            eventName = Analytics.Event.ViewApprovals;
            break;
        case ReleaseStepType.Submission:
            eventName = Analytics.Event.ViewSubmission;
            break;
        case ReleaseStepType.StoreReview:
            eventName = Analytics.Event.ViewAppReview;
            break;
        case ReleaseStepType.Takeoff:
            eventName = Analytics.Event.ViewTakeoff;
            break;
        case ReleaseStepType.VCSDistribution:
            eventName = Analytics.Event.ViewTakeoff;
            break;
        case ReleaseStepType.CIDistribution:
            eventName = Analytics.Event.ViewTakeoff;
            break;
        default:
            eventName = null;
    }

    if (eventName) {
        yield* call(Analytics.track, eventName, allProperties);
    }
}

function* trackBuildDistroEventSaga(action: TrackBuildDistroEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const bucket = yield select(selectBuildDistributionBucketById, action.payload.bucketId!);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);
    const eventName = action.payload.eventName;

    const allProperties = allBuildDistroPropertiesFrom(
        org,
        app,
        bucket,
        appIdsInOrg,
        appGroupNamesInOrg,
        undefined,
        action.payload.extraProperties,
    );
    if (eventName) {
        yield* call(Analytics.track, eventName, allProperties);
    }
}

function* trackStepConfigEventSaga(action: TrackStepConfigEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const user = yield select(selectUser);
    const stepConfig = yield select(selectStepConfig, action.payload.stepConfigId);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const baseProperties = allReleasePropertiesFrom(org, app, undefined, appIdsInOrg, appGroupNamesInOrg);
    const userProps = Analytics.userProperties(user) ?? {};
    const stepConfigProps = Analytics.stepConfigProperties(stepConfig) ?? {};

    yield* call(Analytics.track, action.payload.eventName, {
        ...baseProperties,
        ...userProps,
        ...stepConfigProps,
    });
}

function* trackUserEventSaga(action: TrackUserEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const user = yield select(selectUser);
    const eventName = action.payload.eventName;
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);
    const userProps = Analytics.userProperties(user) ?? {};

    const allProperties = allReleasePropertiesFrom(org, app, undefined, appIdsInOrg, appGroupNamesInOrg);
    if (eventName) {
        yield* call(Analytics.track, eventName, { ...allProperties, ...userProps });
    }
}

function* trackOnboardingEventSaga(action: TrackOnboardingEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const user = yield select(selectUser);
    const eventName = action.payload.eventName;
    const taskType = action.payload.taskType;
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);
    const userProps = Analytics.userProperties(user) ?? {};
    const taskProps = {
        taskType,
    };

    const allProperties = allReleasePropertiesFrom(org, app, undefined, appIdsInOrg, appGroupNamesInOrg);
    if (eventName) {
        yield* call(Analytics.track, eventName, { ...allProperties, ...userProps, ...taskProps });
    }
}

function* trackAddAppEvent(orgId: string, responseArray: CreateAppApiResponse[]) {
    const appsProperties: AppProperties[] = [];
    const appsUseWorkflows: boolean[] = [];
    for (const response of responseArray) {
        for (const appData of response.apps) {
            const app = yield select(selectApp, appData.appId);
            const usesWorkflows = !!app && getAppUsesWorkflows(app);
            appsUseWorkflows.push(usesWorkflows);
            const properties = app ? Analytics.appProperties(app) : null;
            if (properties) {
                appsProperties.push(properties);
            }
        }
    }

    const user = yield select(selectUser);
    const userProperties = Analytics.userProperties(user) ?? {};

    const org = yield select(selectOrg, orgId);
    const appsInOrg = yield select(selectAllAppsIdsInOrg, org?.orgId);
    const appGroupsInOrg = yield select(selectAllAppGroupNamesInOrg, org?.orgId);
    const usesWorkflows = appsUseWorkflows.some((value) => value === true);
    const orgProperties =
        org && appGroupsInOrg && appsInOrg ?
            (Analytics.orgProperties(org, appsInOrg, appGroupsInOrg, usesWorkflows) ?? {})
        :   {};

    yield* call(Analytics.track, Analytics.Event.AddApp, { appsProperties, userProperties, orgProperties }, [
        Analytics.TrackingService.LogRocket,
    ]);
}

function* trackSignUpWithEmailPasswordEvent(userId: string) {
    yield* call(Analytics.track, Analytics.Event.SignUp, { userId: userId, email: userId }, [
        Analytics.TrackingService.LogRocket,
    ]);
}

function logrocketIdentify(response: DashboardState) {
    // LogRocket

    // don't record on dev mode
    if (!response.user || process.env.NODE_ENV == 'development') {
        return;
    }

    const user = response.user;

    let orgId: string | undefined;
    if (response.organizations.length !== 0) {
        orgId = response.organizations[0].id;
    }

    const groupsString = response.user.groups.join(', ');
    const permissionsString = response.user.permissions.join(', ');

    const userProperties = {
        roles: groupsString,
        permissions: permissionsString,
        email: response.user.email,
    };

    if (orgId) {
        userProperties[orgId] = orgId;
    }

    Analytics.identify(user.uuid, userProperties, Analytics.TrackingService.LogRocket, orgId);
}

function amplitudeIdentifyAndStartExperimentsClient(response: DashboardState) {
    if (!response.user) {
        return;
    }

    const orgId = response.organizations[0]?.id;
    const userProperties = Analytics.userProperties(response.user);
    if (userProperties) {
        Analytics.identify(
            response.user.uuid,
            { ...userProperties, navType: getCurrentThemeMode() },
            Analytics.TrackingService.Amplitude,
        );
    }

    const experimentUser: InternalFeatureFlags.ExperimentUser = {
        user_properties: {
            orgId: orgId,
        },
        groups: {
            org: [orgId],
        },
    };

    InternalFeatureFlags.startAmplitudeExperimentClient(experimentUser);
}

function* getUserflowUserAttributes(user: User) {
    const org: OrganizationEntity = yield select(selectOrg);
    const mergedAccountsEnabled = yield select(selectMergeAccountsEnabled, org.id);
    const appCount = yield select(selectAppCount);
    const releasesCount = yield select(selectReleaseCount);
    const isAdmin = yield select(selectUserIsAdmin);
    const canEnableMergeAccountsSetting = yield select(selectCanEnableMergeAccountsSetting, org.id);

    const orgSubscriptionPlan = org.subscriptionInfo?.subscriptionStatus;
    const orgTrialDaysRemaining = org.subscriptionInfo?.trialDaysRemaining;
    const deviceType = window.innerWidth > 800 ? 'desktop' : 'mobile';

    return {
        email: user.email,
        name: user.firstName,
        roles: user.groups,
        signed_up_at: user.createdAt,
        num_of_apps: appCount,
        num_of_releases: releasesCount,
        is_admin: isAdmin,
        merge_accounts_to_org_enabled: mergedAccountsEnabled,
        org_id: org.orgId,
        can_enable_merge_accounts_setting: canEnableMergeAccountsSetting,
        org_users_count: org.users.length,
        needs_password_reset: user.needsNewPassword,
        org_subscription_plan: orgSubscriptionPlan,
        org_trial_days_remaining: orgTrialDaysRemaining,
        device_type: deviceType,
        stape_id: getCookie(STAPE_ID_COOKIE_KEY),
    };
}

function* userFlowIdentify() {
    const user = yield select(selectUser);
    const signature = yield select(selectUserflowIdentitySignature);

    if (signature && user) {
        try {
            const attributes = yield* call(getUserflowUserAttributes, user);

            userflow.identify(user.uuid, attributes, { signature });
        } catch (e: any) {
            Sentry.captureMessage(`Failed to identify userflow user with error: ${e}`);
        }
    } else {
        const deviceType = window.innerWidth > 800 ? 'desktop' : 'mobile';

        userflow.identifyAnonymous({
            deviceType,
            stapeId: getCookie(STAPE_ID_COOKIE_KEY),
        });
    }
}

// eslint-disable-next-line require-yield
function* userflowLogout() {
    try {
        userflow.reset();
    } catch {
        // No-op
    }
}

function* updateUserflowUser() {
    const user = yield select(selectUser);
    const signature = yield select(selectUserflowIdentitySignature);

    if (user && signature) {
        try {
            const attributes = yield* call(getUserflowUserAttributes, user);

            userflow.updateUser(attributes);
        } catch (e: any) {
            Sentry.captureMessage(`Failed to update userflow user attributes with error: ${e}`);
        }
    }
}

function getCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookie = document?.cookie
        .split(';')
        .map((c) => c.trim())
        .find((c) => c.startsWith(nameEQ));

    return cookie?.substring(nameEQ.length) ?? null;
}

function hubspotIdentify(user: User) {
    const userProperties = HubspotUtils.userProperties(user);

    HubspotUtils.identify(userProperties);
}

function setLastLogin() {
    const now = Date.now();

    Storage.setItem(Storage.LAST_LOGIN, now);
}

function* getAppConfigSaga(action: TryUpdateAppConfigAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const response: ConfigResponse = yield* call(API.getAppConfig);

        yield put(getAppConfigSuccess(response));

        yield spawn(updated, action.type);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* switchOrgFetchState(action: TryChangeOrgFetchStateAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response: DashboardState = yield* call(API.fetchState, action.payload, auth);
        const orgs = response.organizations;

        yield spawn(willUpdate, action.type);

        // give the components a second to update
        yield delay(200);

        // clear any existing state
        yield put(clearState());

        // store the new state
        yield put(fetchStateSuccess(response));

        if (orgs.length > 0) {
            yield put(tryWebsocketDisconnect()); // first disconnect existing connection, it will reconnect on its own with the correct orgId

            const orgId = orgs[0].id;

            Storage.setDefaultOrgIdForUserId(action.payload.userId, orgId);
        }

        // update userflow properties
        yield spawn(updateUserflowUser);

        // TODO: update other third party tracking properties
        // not needed right now since only runway admins can change orgs

        yield spawn(updated, action.type);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* fetchStateSaga(action: TryFetchStateAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const response: DashboardState = yield* call(API.fetchState, action.payload, auth);
        const orgs = response.organizations;

        yield spawn(willUpdate, action.type);

        yield put(fetchStateSuccess(response));

        let orgId = '';
        // Default to empty config = all scripts enabled (all *Disabled fields default to false)
        let scriptsConfig: ClientScriptsConfig = {};

        if (orgs.length > 0) {
            if (DISABLE_WEBSOCKET_CONNECTION !== true) {
                yield put(tryWebsocketConnect());
            }

            orgId = orgs[0].id;

            const org = orgs[0];
            scriptsConfig = org.clientScriptsConfig ?? {};
            initializeClientScripts(scriptsConfig);

            // Fire signup conversion pixels if a pending signup is detected
            const pendingSignup = sessionStorage.getItem('pendingSignupConversion');
            const urlParams = new URLSearchParams(window.location.search);
            const signUpAuthSource = urlParams.get('signUpAuthSource');
            const signupSource = pendingSignup || signUpAuthSource;

            if (signupSource) {
                sessionStorage.removeItem('pendingSignupConversion');
                Analytics.trackSignupConversionPixels(signupSource as GoogleAnalytics.SignUpLoginMethod, {
                    userId: response.user.id,
                    orgId: org.id,
                });
            }
        }

        if (!scriptsConfig.logrocketDisabled) {
            yield spawn(logrocketIdentify, response);
        }

        yield spawn(amplitudeIdentifyAndStartExperimentsClient, response);

        if (!scriptsConfig.userflowDisabled) {
            yield spawn(userFlowIdentify);
        }

        yield spawn(hubspotIdentify, response.user);

        yield spawn(GoogleAnalytics.config, GA_MEASUREMENT_ID, {
            user_id: response.user.id,
            permissions: response.user.permissions,
            org_id: orgId,
        });

        yield spawn(GoogleAnalytics.track, GoogleAnalytics.EventName.Login, { method: 'auth' });

        yield spawn(updated, action.type);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* fetchPaginatedEntitiesSaga(action: TryFetchPaginatedEntitiesAction) {
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));

    try {
        if (action.type === FetchablePaginatedEntityType.Issues) {
            const demoIssues = yield select(selectDemoIssuesForApp, action.payload.data.appId);
            if (demoIssues) {
                const demoResponse = getDemoIssuesResponse(
                    demoIssues,
                    action.payload.data as IssuesRequest,
                    action.payload.limit,
                    action.payload.offset,
                );
                yield put(fetchPaginatedEntitiesUpdateAction(action, demoResponse));
                yield put(fetchPaginatedEntitiesUpdatePaginationDataAction(action, demoResponse));
                yield spawn(updated, action.type, action.payload.id);
                return;
            }
        }

        const auth = yield* call(getAuthCredentialsForSaga);
        const request = fetchPaginatedEntitiesRequestForEntityType(action);

        // Cursor-paginated entities carry a `cursor`; offset-paginated ones use `offset`.
        const pageParam = action.payload.cursor !== undefined ? action.payload.cursor : action.payload.offset;
        const response = yield* call(request, action.payload.data, action.payload.limit, pageParam, auth);
        const updatedAction = fetchPaginatedEntitiesUpdateAction(action, response);
        const updatePaginationDataAction = fetchPaginatedEntitiesUpdatePaginationDataAction(action, response);

        yield put(updatedAction);
        yield put(updatePaginationDataAction);

        yield spawn(updated, action.type, action.payload.id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

const TRIAGE_ISSUES_PAGE_SIZE = 20;

function* refetchIssuesList(orgId: string, appId: string) {
    const filters = yield select((state) => selectTriageFilters(state, appId));
    yield put(
        tryFetchPaginatedEntities(
            FetchablePaginatedEntityType.Issues,
            filters.lastQuery ?? { orgId, appId, statusGroup: filters.statusGroup, sortBy: filters.sortBy },
            TRIAGE_ISSUES_PAGE_SIZE,
            0,
            appId,
        ),
    );
}

function* createIssueSaga(action: TryCreateIssueAction) {
    const { id, orgId, appId, title, description, version, build, sourceIssueIds } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const createdIssue = yield* call(
            API.createRunwayIssue,
            { orgId, appId, title, description, version, build, sourceIssueIds },
            auth,
        );

        // Pin the new issue to the top of the list so it's obvious regardless of the active sort/filter, even if a
        // filter would otherwise exclude it.
        if (createdIssue?.id) {
            yield put(pinCreatedIssue({ appId, issue: createdIssue }));
        }

        // Refetch the current list (page 0) so the new issue shows up — and absorbed origins drop off — under the active filters.
        yield* refetchIssuesList(orgId, appId);
        yield put(newNotification({ title: 'Issue created', message: title }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* addIssueSourcesSaga(action: TryAddIssueSourcesAction) {
    const { id, orgId, appId, issueId, sourceIssueIds } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        yield* call(API.addIssueSources, { orgId, appId, issueId, sourceIssueIds }, auth);

        // Refetch the current list (page 0): the absorbed origins are now deleted and the target gained their sources.
        yield* refetchIssuesList(orgId, appId);
        const count = sourceIssueIds.length;
        yield put(
            newNotification({
                title: 'Source added',
                message: count > 1 ? `${count} sources added` : '1 source added',
            }),
        );
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* unmergeIssueSourcesSaga(action: TryUnmergeIssueSourcesAction) {
    const { id, orgId, appId, issueId, sourceIds, mode } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssue = yield* call(API.unmergeIssueSources, { orgId, appId, issueId, sourceIds, mode }, auth);

        const { statusGroup } = yield select((state) => selectTriageFilters(state, appId));
        yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup }));

        // Refetch the current list (page 0) so each unmerged source shows up as its own new issue.
        yield* refetchIssuesList(orgId, appId);
        const count = sourceIds.length;
        yield put(
            newNotification({
                title: 'Source unmerged',
                message: count > 1 ? `${count} sources unmerged` : '1 source unmerged',
            }),
        );
        yield spawn(updated, action.type, id);
    } catch (e) {
        yield spawn(failure, action.type, (e as Error).message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* updateIssueSaga(action: TryUpdateIssueAction) {
    const { id, orgId, appId, issueId, title, description, version, build } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssue = yield* call(
            API.updateIssue,
            { orgId, appId, issueId, title, description, version, build },
            auth,
        );
        const filters = yield select((state) => selectTriageFilters(state, appId));
        yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* markIssuesAsRelatedSaga(action: TryMarkIssuesAsRelatedAction) {
    const { id, orgId, appId, issueId, relatedIssueIds } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssue = yield* call(API.markIssuesAsRelated, { orgId, appId, issueId, relatedIssueIds }, auth);
        const filters = yield select((state) => selectTriageFilters(state, appId));
        yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        // The link is bidirectional: refresh the other side of each new link too.
        for (const relatedIssueId of relatedIssueIds) {
            const related = yield* call(API.getIssue, { orgId, appId, issueId: relatedIssueId }, auth);
            yield put(issueFetched({ appId, issue: related }));
        }
        yield spawn(updated, action.type, id);
    } catch (e) {
        yield spawn(failure, action.type, e instanceof Error ? e.message : String(e), id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* unmarkIssueAsRelatedSaga(action: TryUnmarkIssueAsRelatedAction) {
    const { id, orgId, appId, issueId, relatedIssueId } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        yield* call(API.unmarkIssueAsRelated, { orgId, appId, issueId, relatedIssueId }, auth);
        // The link is bidirectional and the endpoint returns no entity, so refetch both sides.
        const issue = yield* call(API.getIssue, { orgId, appId, issueId }, auth);
        yield put(issueFetched({ appId, issue }));
        const related = yield* call(API.getIssue, { orgId, appId, issueId: relatedIssueId }, auth);
        yield put(issueFetched({ appId, issue: related }));
        yield spawn(updated, action.type, id);
    } catch (e) {
        yield spawn(failure, action.type, e instanceof Error ? e.message : String(e), id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* updateIssueAssigneesSaga(action: TryUpdateIssueAssigneesAction) {
    const { id, orgId, appId, issueId, assigneeUserIds, assigneeGroupIds, viewType } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssue = yield* call(
            API.updateIssueAssignees,
            { orgId, appId, issueId, assigneeUserIds, assigneeGroupIds, viewType },
            auth,
        );
        const filters = yield select((state) => selectTriageFilters(state, appId));
        yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* transitionIssueSaga(action: TryTransitionIssueAction) {
    const { id, orgId, appId, issueId, targetState, viewType } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssue = yield* call(API.transitionIssue, { orgId, appId, issueId, targetState, viewType }, auth);
        const filters = yield select((state) => selectTriageFilters(state, appId));
        yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* bulkTransitionIssuesSaga(action: TryBulkTransitionIssuesAction) {
    const { id, orgId, appId, issueIds, targetState, viewType } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssues = yield* call(
            API.bulkTransitionIssues,
            { orgId, appId, issueIds, targetState, viewType },
            auth,
        );
        const filters = yield select((state) => selectTriageFilters(state, appId));
        for (const updatedIssue of updatedIssues) {
            yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        }
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* bulkReopenIssuesSaga(action: TryBulkReopenIssuesAction) {
    const { id, orgId, appId, issueIds, viewType } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssues = yield* call(API.bulkReopenIssues, { orgId, appId, issueIds, viewType }, auth);
        const filters = yield select((state) => selectTriageFilters(state, appId));
        for (const updatedIssue of updatedIssues) {
            yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        }
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* groupIssuesSaga(action: TryGroupIssuesAction) {
    const {
        id,
        orgId,
        appId,
        targetIssueId,
        sourceIssueIds,
        title,
        description,
        version,
        formFieldsValues,
        workItems,
        viewType,
    } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const mergedIssue = yield* call(
            API.groupIssues,
            {
                orgId,
                appId,
                targetIssueId,
                sourceIssueIds,
                title,
                description,
                version,
                formFieldsValues,
                workItems,
                viewType,
            },
            auth,
        );

        // Pin the merged issue to the top like a newly created one, so the result of the merge is obvious
        // regardless of the active sort/filter.
        if (mergedIssue?.id) {
            yield put(pinCreatedIssue({ appId, issue: mergedIssue }));
        }

        // Refetch the current list (page 0): the merged sources are now deleted and the target gained them.
        yield* refetchIssuesList(orgId, appId);
        const count = sourceIssueIds.length + 1;
        yield put(newNotification({ title: 'Issues merged', message: `${count} issues merged into one` }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* fetchIosDependenciesForReleaseSaga(action: TryFetchIosDependenciesForReleaseAction) {
    const { orgId, appId, releaseId } = action.payload;
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response = yield* call(API.getIosDependenciesForRelease, { orgId, appId, releaseId }, auth);
        yield put(fetchIosDependenciesForReleaseSuccess({ releaseId, response }));
    } catch (e: any) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* fetchIssueSaga(action: TryFetchIssueAction) {
    const { id, orgId, appId, issueId } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        const demoIssues: IssueEntity[] | undefined = yield select(selectDemoIssuesForApp, appId);
        const demoIssue = demoIssues?.find((candidate) => candidate.id === issueId);
        if (demoIssue) {
            yield put(issueFetched({ appId, issue: demoIssue }));
            yield spawn(updated, action.type, id);
            return;
        }

        const auth = yield* call(getAuthCredentialsForSaga);
        const issue = yield* call(API.getIssue, { orgId, appId, issueId }, auth);
        yield put(issueFetched({ appId, issue }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* requestIssueFixSaga(action: TryRequestIssueFixAction) {
    const { id, orgId, appId, issueId, version, formFieldsValues, workItems, viewType } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssue = yield* call(
            API.requestIssueFix,
            { orgId, appId, issueId, version, formFieldsValues, workItems, viewType },
            auth,
        );
        const filters = yield select((state) => selectTriageFilters(state, appId));
        yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* updateIssueFixRequestSaga(action: TryUpdateIssueFixRequestAction) {
    const { id, orgId, appId, issueId, formFieldsValues, version } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssue = yield* call(
            API.updateIssueFixRequest,
            { orgId, appId, issueId, formFieldsValues, version },
            auth,
        );
        const filters = yield select((state) => selectTriageFilters(state, appId));
        yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* reopenIssueSaga(action: TryReopenIssueAction) {
    const { id, orgId, appId, issueId, reason, viewType } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);
        const auth = yield* call(getAuthCredentialsForSaga);
        const updatedIssue = yield* call(API.reopenIssue, { orgId, appId, issueId, reason, viewType }, auth);
        const filters = yield select((state) => selectTriageFilters(state, appId));
        yield put(issueUpdated({ appId, issue: updatedIssue, statusGroup: filters.statusGroup }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* fetchIssueTimelineSaga(action: TryFetchIssueTimelineAction) {
    const { id, orgId, appId, issueId } = action.payload;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        const demoTimeline = yield select(selectDemoIssueTimeline, issueId);
        if (demoTimeline) {
            yield put(fetchIssueTimelineSuccess({ issueId, events: demoTimeline }));
            yield spawn(updated, action.type, id);
            return;
        }

        const auth = yield* call(getAuthCredentialsForSaga);
        const { events } = yield* call(API.getIssueTimeline, { orgId, appId, issueId }, auth);
        yield put(fetchIssueTimelineSuccess({ issueId, events }));
        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* fetchEntitySaga(action: TryFetchEntityAction) {
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const request = fetchEntityRequestForEntityType(action);

        const response = yield* call(request, action.payload.data, auth);
        const updatedAction = fetchEntityUpdateAction(action, response);

        yield put(updatedAction);

        yield spawn(updated, action.type, action.payload.id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

// common actions wrapper for all actions that require loading, optional paginationData and failure/warning/info handling. Can and most likely should be re-used for all actions that require these features
function* commonActionsWrapper<T extends CommonSagaActionsData>(
    action: T,
    tryBlock: (action: T, auth: AuthCredentials) => Generator<any, RunwayResponseV2>,
) {
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));
    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response = yield* tryBlock(action, auth);

        // if paginationData is provided, update it
        if (action.paginationData) {
            yield put(updatePaginationDataAction(action));
        }

        switch (response.type) {
            case RunwayResponseType.Info:
            case RunwayResponseType.Warning:
            case RunwayResponseType.Success:
                yield spawn(updated, action.type, action.payload.id, response.type);
                break;
            default:
                throw new Error(`Unexpected response type: ${response.type}`);
        }
    } catch (e: any) {
        if (e instanceof RunwayResponseError) {
            // TODO: at some point we might want to use the data from the RunwayResponseError to display a more detailed error message like validation data per field for example. That should be handled here by using `e.runwayResponse.data`.
            //  For now we just display the error message.
            yield spawn(failure, action.type, e.message, action.payload.id);
        } else {
            yield spawn(failure, action.type, e.message, action.payload.id);
        }
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* fetchEntityV2Saga(action: TryFetchEntityActionV2) {
    yield* commonActionsWrapper<TryFetchEntityActionV2>(action, function* (action, auth) {
        const request = fetchEntityRequestForEntityTypeV2(action);

        const response = yield* call(request, action.payload.data, auth);

        const models = runwayModelsFromFetchEntityResponse(action, response);

        yield* call(updateRunwayModelsSaga, models);

        return response;
    });
}

function* runwayUpdatableSaga(updatable: TryUpdatableAction) {
    yield* commonActionsWrapper<TryUpdatableAction>(updatable, function* (updatable, auth) {
        const request = updatableRequestForUpdatable(updatable.type);
        const response = yield* call(request, updatable.payload.resourceIds, updatable.payload.requestData, auth);

        yield* call(updateRunwayModelsSaga, response.data);
        return response;
    });
}

function* logoutSaga(action: TryLogoutAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.logout, auth);

        yield put(clearAuth());
        yield put(logoutSuccess());

        yield* call(userflowLogout);

        yield spawn(updated, action.type);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* loginSaga(action: TryLoginAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const response: AuthResponse = yield* call(API.login, action.payload);

        if (response.is2FARequired) {
            yield put(updateTwoFactorAuthRequired(response.userId));
        } else if (response.redirectUrl) {
            // redirect instead of saving auth
            yield put(redirectAuthNeeded({ authRedirectUrl: response.redirectUrl }));
        } else {
            yield put(authSuccess(response));
            yield* call(setLastLogin);
            yield* call(Storage.checkAndRedirectToSavedRoute);
        }

        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* signUpSaga(action: TrySignUpAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const response: AuthResponse = yield* call(API.signUp, action.payload);

        if (response.is2FARequired) {
            yield put(updateTwoFactorAuthRequired(response.userId));
        } else {
            yield put(authSuccess(response));
            yield* call(setLastLogin);
            yield* call(Storage.checkAndRedirectToSavedRoute);
        }

        yield spawn(updated, action.type);

        yield* call(trackSignUpWithEmailPasswordEvent, response.userId);

        // Mark that signup conversion pixels should fire after scripts are loaded in fetchStateSaga
        sessionStorage.setItem('pendingSignupConversion', 'emailPassword');
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* verifyAuthCodeSaga(action: TryVerifyAuthCodeAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const response: AuthResponse = yield* call(API.verify2FACode, action.payload);

        if (response.redirectUrl) {
            // redirect instead of saving auth
            yield put(redirectAuthNeeded({ authRedirectUrl: response.redirectUrl }));
        } else {
            yield put(authSuccess(response));
            yield* call(setLastLogin);
            yield* call(Storage.checkAndRedirectToSavedRoute);
        }

        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* refreshToken(action: TryRefreshAuthTokenAction) {
    yield put(loadingActionStart(action.type));

    try {
        const response: AuthResponse = yield* call(API.refreshToken, action.payload);

        yield put(authSuccess(response));
        yield* call(Storage.checkAndRedirectToSavedRoute);

        yield* call(setLastLogin);

        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);

        if (error.name === API.RunwayErrorType.Unauthorized) {
            // Save the current route to local storage before redirecting
            const currentRoute = `${window.location.pathname}${window.location.search}`;
            yield* call(Storage.setAuthRedirectRoute, currentRoute);

            // refresh token failed, log out
            yield put(clearAuth());
            yield put(logoutSuccess());
        }
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* newPasswordSaga(action: TryNewPasswordAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const user = yield* call(API.newPassword, action.payload, auth);

        yield put(newPasswordSuccess(user));
        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateUserDevicesSaga(action: UpdateUserDevicesAction) {
    const { userId } = action.payload;
    yield put(clearFailure(action.type, userId));
    yield put(loadingActionStart(action.type, userId));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const user = yield* call(API.addUserDevice, action.payload, auth);

        yield put(updateUserDevicesSuccess(user));
        yield spawn(updated, action.type, userId);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, userId);
    } finally {
        yield put(loadingStopAction(action.type, userId));
    }
}

function* updateShouldShowSimplifiedBdUISaga(action: UpdateShouldShowSimplifiedBDUIAction) {
    yield put(clearFailure(action.type, action.payload.userId));
    yield put(loadingActionStart(action.type, action.payload.userId));
    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const user = yield* call(API.updateShouldShowSimplifiedBdUI, action.payload, auth);

        yield put(updateShouldShowSimplifiedBdUISuccess(user));
        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.userId));
    }
}

function* verifyCommsUserSaga(action: VerifyCommsUserAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));
    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        yield* call(API.verifyCommsUser, action.payload, auth);

        yield put(verifyCommsUserSuccess());
        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* willUpdate(name: Updatable | string, id?: number | string, waitPeriod = 500) {
    yield put(willUpdateStartAction(name, id));
    yield delay(waitPeriod);
    yield put(willUpdateStopAction(name, id));
}

function* updated(
    name: Updatable | string,
    id?: number | string,
    responseType: NonErrorRunwayResponseTypes = null,
    waitPeriod = 500,
) {
    yield put(updatedStartAction(name, id, responseType));
    yield delay(waitPeriod);
    yield put(updatedStopAction(name, id, responseType));
}

function* failure(name: Updatable | string, message: string, id?: number | string, waitPeriod = 500) {
    yield put(requestFailedAction(name, message, id));
    yield delay(waitPeriod);
    yield put(clearFailure(name, id));
}

function* verifyCanUpdateRelease(releaseId: string) {
    const isReleaseDemoModeEnabled = yield select(selectIsDemoModeEnabledForRelease, releaseId);
    const isDemoInstance = yield select(selectIsDemoInstance);

    if (isReleaseDemoModeEnabled || isDemoInstance) {
        throw Error('You are viewing this release in demo mode. All actions are readonly.');
    }
}

function* verifyCanUpdateApp() {
    const isDemoModeEnabled = yield select(selectIsAppsDemoModeEnabled);
    const isDemoInstance = yield select(selectIsDemoInstance);

    if (isDemoModeEnabled || isDemoInstance) {
        throw Error('You are in demo mode. All actions are readonly.');
    }
}

function* updateReleaseSaga(action: TryUpdateReleaseAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.requestData.releaseId);
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = yield* call(updateReleaseApiRequestForReleaseUpdatable, action);

        const auth = yield* call(getAuthCredentialsForSaga);

        const release: Release = yield* call(request, action.payload.requestData, auth);

        const expectedReleaseId = action.payload.requestData.releaseId;
        if (!release?.id) {
            throw new Error('Release update succeeded but the response was missing a release id.');
        }

        const canReturnDifferentRelease = action.type === ReleaseUpdatable.BumpVersion;
        if (!canReturnDifferentRelease && expectedReleaseId != null && release.id !== expectedReleaseId) {
            Sentry.captureMessage('Release update response id mismatch', {
                level: 'warning',
                extra: { expectedReleaseId, responseReleaseId: release.id, updateType: action.type },
            });
        }

        const updatedReleaseResponse: UpdateReleaseResponse = {
            releaseId: release.id,
            release,
        };

        yield put(updateReleaseSuccess(updatedReleaseResponse));

        yield spawn(updated, action.type, action.payload.id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* updateFeatureFlagsSaga(action: TryUpdateFeatureFlagsAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.requestData.releaseId);
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = yield* call(updateFeatureFlagsRequestForFeatureFlagUpdatable, action);

        const auth = yield* call(getAuthCredentialsForSaga);

        const featureFlag = yield* call(request, action.payload.requestData, auth);

        yield put(
            updateFeatureFlagsSuccess({
                releaseId: action.payload.requestData.releaseId,
                featureFlags: [featureFlag],
            }),
        );

        yield spawn(updated, action.type, action.payload.id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* updateReleaseStepSaga(action: TryUpdateReleaseStepAction<ReleaseStepUpdatable>) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.resourceIds.releaseId);
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = yield* call(updateReleaseStepApiRequestForReleaseStepUpdatableType, action.type);

        const auth = yield* call(getAuthCredentialsForSaga);

        const models = yield* call(request, action.payload.resourceIds, action.payload.requestData, auth);

        yield* call(updateRunwayModelsSaga, models);

        yield spawn(updated, action.type, action.payload.id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* updateRunwayModelsSaga(runwayModels?: RunwayModelsResponse) {
    if (!runwayModels) {
        return;
    }

    const {
        stepRuns,
        stepConfigs,
        releaseSteps,
        checklistItemTemplates,
        automations,
        releases,
        orgEntity,
        apps,
        workflowRunStepRunGraphs,
        workflowStepGraphs,
        deletedChecklistItemTemplateIds,
        workflowOverview,
        orgChecklistItemTemplates,
        orgUsersVCSUserData,
    } = runwayModels;

    if (releaseSteps) {
        yield put(updateReleaseSteps(releaseSteps));
    }

    if (stepRuns) {
        yield put(updateStepRuns(stepRuns));
        for (const stepRun of stepRuns) {
            yield put(stepRunsSummaryActions.updateStepRun(stepRun));
        }
    }

    if (stepConfigs) {
        yield put(updateStepConfigs(stepConfigs));
    }

    if (checklistItemTemplates) {
        yield put(updateChecklistItemTemplates(checklistItemTemplates));
    }

    if (automations) {
        yield put(updateAutomations(automations));
    }

    if (workflowRunStepRunGraphs) {
        yield put(updateWorkflowRunStepRunGraphs(workflowRunStepRunGraphs));
    }

    if (workflowStepGraphs) {
        yield put(updateWorkflowStepGraphs(workflowStepGraphs));
    }

    if (workflowOverview) {
        yield put(updateWorkflowOverview(workflowOverview));
    }

    if (releases) {
        // probably a left over from a previous implementation but I'm mapping the releases to a ConnectedReleaseResponse object which requires appId and orgId, however, these are never used. It's ok... this will not exist once workflowRuns replace releases...
        yield put(releasesUpdated(releases.map((release) => ({ appId: '', orgId: '', release }))));
    }

    if (orgEntity) {
        yield put(updateOrgSettingsSuccessAction(orgEntity));
    }

    if (apps) {
        yield put(appsUpdated(apps.map((app) => ({ orgId: '', orgIdParam: '', appGroupId: '', app: app }))));
    }

    if (orgChecklistItemTemplates) {
        yield put(updateOrgChecklistItemTemplates(orgChecklistItemTemplates));
    }

    if (orgUsersVCSUserData) {
        yield put(updateOrgUsersVCSUserData(orgUsersVCSUserData));
    }

    // -------- delete entities ---------

    if (deletedChecklistItemTemplateIds) {
        yield put(deleteChecklistItemTemplates(deletedChecklistItemTemplateIds));
    }
}

function* updateChecklistItemSaga(action: TryUpdateChecklistItemAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.requestData.releaseId);
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = yield* call(updateApiForChecklistItemUpdatable, action);

        const auth = yield* call(getAuthCredentialsForSaga);

        const response: ChecklistItemUpdatableAPIResponse = yield* call(request, action.payload.requestData, auth);

        if (response.release) {
            const release = response.release;

            const updatedReleaseResponse: UpdateReleaseResponse = {
                releaseId: release.id,
                release,
            };

            yield put(updateReleaseSuccess(updatedReleaseResponse));
        } else if (response.rolloutMonitoring) {
            const rolloutMonitoringResponse: RolloutMonitoringResponse = {
                rolloutMonitoring: response.rolloutMonitoring,
                releaseId: action.payload.requestData.releaseId,
                appId: action.payload.requestData.appId,
                orgId: action.payload.requestData.orgId,
            };

            yield put(updateRolloutMonitoringForReleases([rolloutMonitoringResponse]));
        }

        yield spawn(updated, action.type, action.payload.id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* createReleaseSaga(action: TryNewReleaseAction) {
    yield put(clearFailure(action.type, action.payload.releaseId));
    yield put(loadingActionStart(action.type, action.payload.releaseId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const release = yield* call(API.createNewRelease, action.payload.request, auth);
        const actionPayload: ConnectedReleaseResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            orgIdParam: action.payload.orgIdParam,
            appIdParam: action.payload.appIdParam,
            release,
        };

        yield put(invalidateAppHomeCache({ orgId: actionPayload.orgId, appId: actionPayload.appId }));

        if (action.payload.isRollbackConversion) {
            yield spawn(updated, action.type, action.payload.releaseId);

            // wait for state to update with deleted release
            yield delay(200);

            yield put(newReleaseSuccessAction(actionPayload));
        } else {
            yield put(newReleaseSuccessAction(actionPayload));

            yield spawn(updated, action.type);
        }
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.releaseId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.releaseId));
    }
}

function* updateReleaseEntitySaga(action: TryUpdateReleaseEntityAction) {
    const releaseId = action.payload.request.releaseId;

    try {
        yield* call(verifyCanUpdateRelease, releaseId);
        yield put(clearFailure(action.type, releaseId));
        yield put(loadingActionStart(action.type, releaseId));

        const auth = yield* call(getAuthCredentialsForSaga);

        const release = yield* call(API.updateRelease, action.payload.request, auth);
        const actionPayload: ConnectedReleaseResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            orgIdParam: action.payload.orgIdParam,
            appIdParam: action.payload.appIdParam,
            release,
        };

        yield put(updateReleaseEntitySuccess(actionPayload));
        yield spawn(updated, action.type, releaseId);

        const prevReleaseId = action.payload.request.releaseId;

        if (prevReleaseId !== release.id) {
            // release id changed, need to delete previous entity from store
            const deleteEntityPayload: DeleteReleaseEntityPayload = {
                appId: action.payload.appId,
                orgId: action.payload.orgId,
                releaseId: action.payload.request.releaseId,
                orgIdParam: action.payload.orgIdParam,
                appIdParam: action.payload.appIdParam,
            };

            // wait for state to update with updated release
            yield delay(1600);

            // delete previous release
            yield put(deleteReleaseEntity(deleteEntityPayload));
        }
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, releaseId);
    } finally {
        yield put(loadingStopAction(action.type, releaseId));
    }
}

function* deleteReleaseSaga(action: TryDeleteReleaseAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.releaseId);
        yield put(clearFailure(action.type, action.payload.releaseId));
        yield put(loadingActionStart(action.type, action.payload.releaseId));

        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(willUpdate, action.type, action.payload.releaseId);

        yield* call(API.deleteRelease, action.payload, auth);

        const deleteEntityPayload: DeleteReleaseEntityPayload = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            orgIdParam: action.payload.orgIdParam,
            appIdParam: action.payload.appIdParam,
            releaseId: action.payload.releaseId,
        };

        yield put(invalidateAppHomeCache({ orgId: deleteEntityPayload.orgId, appId: deleteEntityPayload.appId }));

        yield spawn(updated, action.type, action.payload.releaseId);

        // wait for state to update with deleted release
        yield delay(500);

        // delete previous release
        yield put(deleteReleaseEntity(deleteEntityPayload));
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.releaseId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.releaseId));
    }
}

// build distro

function* createBuildDistributionBucketSaga(action: TryNewBuildDistributionBucketAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const newBucket = yield* call(API.createBuildDistributionBucket, action.payload, auth);
        const actionPayload: NewBuildDistributionBucketSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            bucket: newBucket,
        };

        yield put(newBuildDistributionBucketSuccess(actionPayload));

        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* shareBuildDistributionBuildWithTestersSaga(action: ShareBuildDistributionBuildWithTestersAction) {
    yield put(clearFailure(action.type, action.payload.buildId));
    yield put(loadingActionStart(action.type, action.payload.buildId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const build = yield* call(API.shareBuildDistributionBuildWithTesters, action.payload, auth);
        const actionPayload: ShareBuildDistributionBuildWithTestersSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            build,
        };

        yield put(shareBuildDistributionBuildWithTestersSuccess(actionPayload));

        yield spawn(updated, action.type, action.payload.buildId);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.buildId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.buildId));
    }
}

function* triggerReleaseWorkflowBuildSaga(action: TriggerReleaseWorkflowBuildAction) {
    yield put(clearFailure(action.type, action.payload.releaseId));
    yield put(loadingActionStart(action.type, action.payload.releaseId));

    try {
        yield* call(verifyCanUpdateRelease, action.payload.releaseId);

        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.triggerBuildWorkflow, action.payload, auth);

        yield spawn(updated, action.type, action.payload.releaseId);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.releaseId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.releaseId));
    }
}

function* triggerBuildDistributionBuildSaga(action: TriggerBuildDistributionBuildAction) {
    yield put(clearFailure(action.type, action.payload.bucketId));
    yield put(loadingActionStart(action.type, action.payload.bucketId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.triggerBuildDistributionBucketWorkflow, action.payload, auth);

        yield spawn(updated, action.type, action.payload.bucketId);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.bucketId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.bucketId));
    }
}

function* updateBuildDistributionBuildTesterNotesSaga(action: UpdateBuildDistributionBuildTesterNotesAction) {
    yield put(clearFailure(action.type, action.payload.buildId));
    yield put(loadingActionStart(action.type, action.payload.buildId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const updatedBuild = yield* call(API.updateBuildDistributionBuildTesterNotes, action.payload, auth);
        const actionPayload: UpdateBuildDistributionBuildTesterNotesSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            build: updatedBuild,
        };

        yield put(updateBuildDistributionBuildTesterNotesSuccess(actionPayload));

        yield spawn(updated, action.type, action.payload.buildId);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.buildId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.buildId));
    }
}

function* archiveBuildDistributionBuildSaga(action: ArchiveBuildDistributionBuildAction) {
    yield put(clearFailure(action.type, action.payload.buildId));
    yield put(loadingActionStart(action.type, action.payload.buildId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const updatedBuild = yield* call(API.archiveBuildDistributionBuild, action.payload, auth);
        const actionPayload: ArchiveBuildDistributionBuildSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            build: updatedBuild,
        };

        yield put(archiveBuildDistributionBuildSuccess(actionPayload));

        yield spawn(updated, action.type, action.payload.buildId);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.buildId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.buildId));
    }
}

function* archiveBuildDistributionBucketSaga(action: TryArchiveBuildDistributionBucketAction) {
    yield put(clearFailure(action.type, action.payload.bucketId));
    yield put(loadingActionStart(action.type, action.payload.bucketId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const archivedBucket = yield* call(API.archiveBuildDistributionBucket, action.payload, auth);
        const actionPayload: ArchiveBuildDistributionBucketSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            bucket: archivedBucket,
        };

        yield put(archiveBuildDistributionBucketSuccess(actionPayload));

        yield spawn(updated, action.type, action.payload.bucketId);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.bucketId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.bucketId));
    }
}

function* updateBuildDistributionBucketSaga(action: TryUpdateBuildDistributionBucketAction) {
    let id: string;
    switch (action.type) {
        case BuildDistributionUpdatable.RemoveBuildDistroBucketMember:
        case BuildDistributionUpdatable.UpdateBuildDistroBucketMemberPermissions:
            id = (action.payload as BucketMemberEntityRequest).memberId;
            break;
        case BuildDistributionUpdatable.UpdateBuildDistroBucketNotificationSettings:
            id = (action.payload as UpdateBuildDistroBucketNotificationSettingsRequest).notificationId;
            break;
        case BuildDistributionUpdatable.UpdateBuildDistroBucketAutomationSettings:
            id =
                action.payload.bucketId +
                (action.payload as UpdateBuildDistroBucketAutomationSettingsRequest).automationId;
            break;
        default:
            id = action.payload.bucketId;
            break;
    }

    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const request = yield* call(updateBuildDistributionBucketRequestForAction, action);

        const bucket: BuildDistroBucketBase = yield* call(request, action.payload, auth);

        yield put(
            updateDistributionBucketSuccess({
                bucket,
                appId: action.payload.appId,
                orgId: action.payload.orgId,
                bucketId: action.payload.bucketId,
            }),
        );

        // Just for this case, since removing the member would remove the component in charge of displaying the success message
        if (action.type === BuildDistributionUpdatable.RemoveBuildDistroBucketMember) {
            globalMessage.success(`Successfully removed member!`);
        }

        yield spawn(updated, action.type, id);
    } catch (e: any) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* updateAppSettingsSaga(action: TryUpdateAppSettingsAction) {
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));

    try {
        yield* call(verifyCanUpdateApp);

        const request = appSettingsApiRequestForAppUpdateType(action.type);
        const auth = yield* call(getAuthCredentialsForSaga);

        const response: AppSettings = yield* call(request, action.payload.requestData, auth);
        yield put(updateAppSettingsSuccessAction({ appId: action.payload.requestData.appId, appSettings: response }));

        yield spawn(updated, action.type, action.payload.id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* updateOrgSettingsSaga(action: TryUpdateOrgSettingsAction) {
    yield delay(300); // give it a second
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));

    try {
        const request = orgSettingsApiRequestForOrgUpdateType(action.type);
        const auth = yield* call(getAuthCredentialsForSaga);

        if (action.type === OrgSettingsUpdatable.DeleteCustomGroup) {
            const models = yield* call(request, action.payload.requestData, auth);
            yield* call(updateRunwayModelsSaga, models as RunwayModelsResponse);
        } else if (action.type === OrgSettingsUpdatable.SetDefaultGroupsDisabled) {
            const response = (yield* call(
                request,
                action.payload.requestData,
                auth,
            )) as SetDefaultGroupsDisabledResponse;
            yield put(updateOrgSettingsSuccessAction(response.orgEntity));
            if (response.skipped.length > 0) {
                const skippedNames = response.skipped.map((s) => s.name || s.groupId).join(', ');
                globalMessage.warning(`Some groups couldn't be disabled (still have members): ${skippedNames}`);
            }
        } else if (action.type === OrgSettingsUpdatable.UpdateUserGroupsForDirectorySyncGroup) {
            yield* call(request, action.payload.requestData, auth);
        } else {
            const response = (yield* call(request, action.payload.requestData, auth)) as OrganizationEntity;
            yield put(updateOrgSettingsSuccessAction(response));
        }

        yield spawn(updated, action.type, action.payload.id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* addPublicApiSaga(action: TryAddPublicApiKeyAction) {
    yield delay(300); // give it a second
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const response: CreatePublicApiKeyResponse = yield* call(API.addPublicApiKey, action.payload, auth);

        const apiKeyData: CreateApiKeyData = {
            keyValue: response.apiKey?.keyValue,
        };

        yield put(createPublicApiKey(apiKeyData));
        yield put(orgStateUpdated(response.orgEntity));

        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateAppSettingsV2Saga(action: TryUpdateAppSettingsV2Action) {
    try {
        yield* call(verifyCanUpdateApp);

        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = appSettingsV2ApiRequestForAppUpdateType(action.type);
        const auth = yield* call(getAuthCredentialsForSaga);

        const response: AppSettingsV2APIResponse = yield* call(request, action.payload.requestData, auth);

        // avoid updating app settings twice if app entity is present

        if (response.appEntity) {
            yield put(appEntityUpdated(response.appEntity));
        } else if (response.appSettings) {
            yield put(
                updateAppSettingsSuccessAction({
                    appId: action.payload.requestData.appId,
                    appSettings: response.appSettings,
                }),
            );
        }

        if ((response.releases?.length ?? 0) > 0) {
            const updatedReleases = response.releases!.map((release) => {
                return {
                    appId: action.payload.requestData.appId,
                    orgId: action.payload.requestData.orgId,
                    release,
                };
            });

            yield put(releasesUpdated(updatedReleases));
        }

        if ((response.buildDistributionBuckets?.length ?? 0) > 0) {
            yield put(
                updateDistributionBucketsSuccess({
                    buckets: response.buildDistributionBuckets!,
                    appId: action.payload.requestData.appId,
                    orgId: action.payload.requestData.orgId,
                }),
            );
        }

        if ((response.integrations?.length ?? 0) > 0) {
            yield put(
                updateIntegrationsSuccess({
                    appId: action.payload.requestData.appId,
                    integrations: response.integrations!,
                }),
            );
        }

        if (response.organizationEntity) {
            yield put(updateOrgSettingsSuccessAction(response.organizationEntity));
        }

        if (response.rolloutMonitoringForReleases) {
            const rolloutMonitoringResponses: RolloutMonitoringResponse[] = [];
            for (const releaseId of Object.keys(response.rolloutMonitoringForReleases)) {
                const rolloutMonitoringResponse: RolloutMonitoringResponse = {
                    rolloutMonitoring: response.rolloutMonitoringForReleases[releaseId],
                    releaseId: releaseId,
                    appId: action.payload.requestData.appId,
                    orgId: action.payload.requestData.orgId,
                };

                rolloutMonitoringResponses.push(rolloutMonitoringResponse);
            }

            if (rolloutMonitoringResponses.length > 0) {
                yield put(updateRolloutMonitoringForReleases(rolloutMonitoringResponses));
            }
        }

        yield spawn(updated, action.type, action.payload.id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* createIntegrationSaga(action: TryCreateIntegrationAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response: CreateDeleteIntegrationResponse = yield* call(API.createIntegration, action.payload, auth);

        yield put(createIntegrationSuccess(response));

        yield spawn(updated, action.type, response.integrationEntity?.installationId ?? null);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* refreshIntegrationSaga(action: TryRefreshIntegrationAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response: CreateDeleteIntegrationResponse = yield* call(API.refreshIntegration, action.payload, auth);

        yield put(refreshIntegrationSuccess(response));

        yield spawn(updated, action.type, response.integrationEntity?.installationId ?? null);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateIntegrationSaga(action: TryUpdateIntegrationAction) {
    const id = action.payload.integrationId;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const response = yield* call(API.updateIntegration, action.payload, auth);

        const appSettings = response;
        const appId = action.payload.appId;

        yield put(updateIntegrationSuccess({ appId, appSettings }));
        yield spawn(updated, action.type, id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* updateIntegrationAliasSaga(action: TryUpdateIntegrationAliasAction) {
    const id = action.payload.integrationId;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const response = yield* call(API.updateIntegrationAlias, action.payload, auth);

        const appSettings = response;
        const appId = action.payload.appId;

        yield put(updateIntegrationSuccess({ appId, appSettings }));
        yield spawn(updated, action.type, id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* deleteIntegrationSaga(action: DeleteIntegrationAction) {
    const id = action.payload.integrationId;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const response = yield* call(API.deleteIntegration, action.payload, auth);

        yield put(deleteIntegrationSuccess(response));

        // intentionally not passing the integration id to updated, as the integration is already deleted
        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* refreshIntegrations(action: TryRefreshIntegrationsAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.refreshIntegrations, action.payload, auth);

        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateDevicesSaga(action: TryUpdateDevicesAction) {
    yield put(clearFailure(action.type, action.payload.appId));
    yield put(loadingActionStart(action.type, action.payload.appId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const response: GetAllDevicesResponse = yield* call(
            updateDevicesRequestForAction(action),
            action.payload,
            auth,
        );

        const orgId = action.payload.orgId;
        const appId = action.payload.appId;

        yield put(updateDevicesSuccess({ appId, orgId, ...response }));
        yield spawn(updated, action.type, action.payload.appId);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.appId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.appId));
    }
}

export function* handleStateUpdateEvents(
    events: WebsocketStateUpdateEvent[],
    isAppStateFetchedForApps: Record<string, boolean>,
    packageVersion: string,
) {
    for (const modelType of AllStateUpdateEventModelTypes) {
        const allModelTypeEvents = events.filter((event) => {
            const eventMatchesModelType = event.data.modelType === modelType;
            const eventMatchesPackageVersion = event.version === packageVersion;

            return eventMatchesModelType && eventMatchesPackageVersion;
        });

        if (allModelTypeEvents.length === 0) {
            continue;
        }

        switch (modelType) {
            case ModelType.App: {
                const deletedApps: DeletedAppEntityPayload[] = [];
                const connectedApps: ConnectedAppEntityResponse[] = [];

                allModelTypeEvents.forEach((event) => {
                    if (event.data.deletedAppId) {
                        deletedApps.push({
                            orgId: event.data.orgId,
                            orgIdParam: event.data.orgIdParam,
                            appGroupId: event.data.appGroupId!,
                            appId: event.data.deletedAppId,
                        });
                    } else {
                        const app = event.data.model as App;

                        const isAppStateFetched = isAppStateFetchedForApps[app.id];

                        // only persist app state if it's previously been fetched & persisted
                        if (isAppStateFetched) {
                            connectedApps.push({
                                orgId: event.data.orgId,
                                orgIdParam: event.data.orgIdParam,
                                appGroupId: event.data.appGroupId!,
                                app,
                            });
                        }
                    }
                });

                if (connectedApps.length > 0) {
                    yield put(appsUpdated(connectedApps));

                    if (process.env.NODE_ENV !== Environment.Production) {
                        const message =
                            connectedApps.length > 1 ?
                                `${connectedApps.length} apps updated`
                            :   `App ${connectedApps[0].app.appId} updated`;

                        const notification = {
                            title: '📣 Websocket event',
                            message: message,
                        };

                        yield put(newNotification(notification));
                    }
                }

                if (deletedApps.length > 0) {
                    for (const deletedApp of deletedApps) {
                        yield* call(willUpdate, TRY_DELETE_APP_ENTITY, deletedApp.appId);
                    }

                    yield put(appsDeleted(deletedApps));
                }

                break;
            }
            case ModelType.Org: {
                for (const event of allModelTypeEvents) {
                    const org = event.data.model as OrganizationEntity;

                    yield put(orgStateUpdated(org));

                    if (process.env.NODE_ENV !== Environment.Production) {
                        const notification = {
                            title: '📣 Websocket event',
                            message: `Org ${org.orgId} updated`,
                        };

                        yield put(newNotification(notification));
                    }
                }

                break;
            }
            case ModelType.Release: {
                const deletedReleases: DeleteReleaseEntityPayload[] = [];
                const connectedReleases: ConnectedReleaseResponse[] = [];

                allModelTypeEvents.forEach((event) => {
                    if (event.data.prevReleaseId || event.data.deletedReleaseId) {
                        deletedReleases.push({
                            orgId: event.data.orgId,
                            appId: event.data.appId!,
                            releaseId: (event.data.prevReleaseId ?? event.data.deletedReleaseId)!,
                            appIdParam: event.data.appIdParam!,
                            orgIdParam: event.data.orgIdParam,
                        });
                    }

                    if (!event.data.deletedReleaseId) {
                        const release = event.data.model as Release;
                        const payload: ConnectedReleaseResponse = {
                            appId: event.data.appId!,
                            orgId: event.data.orgId,
                            appIdParam: event.data.appIdParam,
                            orgIdParam: event.data.orgIdParam,
                            release,
                        };

                        connectedReleases.push(payload);
                    }
                });

                if (connectedReleases.length > 0) {
                    yield put(releasesUpdated(connectedReleases));

                    if (process.env.NODE_ENV !== Environment.Production) {
                        const message =
                            connectedReleases.length > 1 ?
                                `${connectedReleases.length} releases updated`
                            :   `Release ${connectedReleases[0].release.releaseId} updated`;

                        const notification = {
                            title: '📣 Websocket event',
                            message: message,
                        };

                        yield put(newNotification(notification));
                    }
                }

                if (deletedReleases.length > 0) {
                    for (const deletedRelease of deletedReleases) {
                        yield* call(willUpdate, TRY_DELETE_RELEASE_ENTITY, deletedRelease.releaseId);
                    }

                    yield put(deleteReleasesTriggeredFromWebsocket(deletedReleases));
                }

                const affectedAppIds = new Set<string>();
                allModelTypeEvents.forEach((event) => {
                    if (event.data.appId) {
                        affectedAppIds.add(event.data.appId);
                    }
                });

                for (const appId of affectedAppIds) {
                    const event = allModelTypeEvents.find((e) => e.data.appId === appId)!;
                    yield put(invalidateAppHomeCache({ orgId: event.data.orgId, appId }));

                    const app = yield select(selectApp, appId);
                    if (app?.workflowId) {
                        yield put(invalidateWorkflowOverviewCache({ workflowId: app.workflowId }));
                    }
                }

                break;
            }
            case ModelType.AppGroup: {
                const deletedAppGroups: DeletedAppGroupPayload[] = [];
                const connectedAppGroups: ConnectedAppGroupEntityResponse[] = [];

                allModelTypeEvents.forEach((event) => {
                    if (event.data.deletedAppGroupId) {
                        deletedAppGroups.push({
                            orgId: event.data.orgId,
                            orgIdParam: event.data.orgIdParam,
                            appGroupId: event.data.deletedAppGroupId,
                        });
                    } else {
                        const appGroup = event.data.model as AppGroup;

                        connectedAppGroups.push({
                            orgId: event.data.orgId,
                            orgIdParam: event.data.orgIdParam,
                            appGroup,
                        });
                    }
                });

                if (connectedAppGroups.length > 0) {
                    yield put(appGroupsUpdated(connectedAppGroups));

                    if (process.env.NODE_ENV !== Environment.Production) {
                        const message =
                            connectedAppGroups.length > 1 ?
                                `${connectedAppGroups.length} app groups updated`
                            :   `App group ${connectedAppGroups[0].appGroup.name} updated`;

                        const notification = {
                            title: '📣 Websocket event',
                            message: message,
                        };

                        yield put(newNotification(notification));
                    }
                }

                if (deletedAppGroups.length > 0) {
                    yield put(appGroupsDeleted(deletedAppGroups));
                }

                break;
            }
            case ModelType.RolloutMonitoring: {
                const rolloutMonitoringResponses: RolloutMonitoringResponse[] = [];
                for (const event of allModelTypeEvents) {
                    const rolloutMonitoring = event.data.model as RolloutMonitoring;

                    const rolloutMonitoringResponse: RolloutMonitoringResponse = {
                        rolloutMonitoring,
                        releaseId: event.data.releaseId!,
                        appId: event.data.appId!,
                        orgId: event.data.orgId,
                    };

                    rolloutMonitoringResponses.push(rolloutMonitoringResponse);
                }

                if (rolloutMonitoringResponses.length > 0) {
                    yield put(updateRolloutMonitoringForReleases(rolloutMonitoringResponses));
                }

                break;
            }
            case ModelType.FeatureFlags: {
                const featureFlagsResponses: FetchFeatureFlagsResponse[] = [];
                for (const event of allModelTypeEvents) {
                    const featureFlags = event.data.model as FeatureFlag[];

                    const featureFlagsResponse: FetchFeatureFlagsResponse = {
                        featureFlags,
                        releaseId: event.data.releaseId!,
                    };

                    featureFlagsResponses.push(featureFlagsResponse);
                }

                if (featureFlagsResponses.length > 0) {
                    yield put(updateFeatureFlagsForReleases(featureFlagsResponses));
                }

                break;
            }
            case ModelType.BuildDistroBucket: {
                for (const event of allModelTypeEvents) {
                    const orgId = event.data.orgId;
                    const appId = event.data.appId;

                    const bucket = event.data.model as BuildDistroBucketBase;
                    if (bucket && bucket.id && orgId && appId) {
                        const response: UpdateBuildDistributionBucketSuccessResponse = {
                            bucket: {
                                ...bucket,
                                disallowedActions: undefined, // permissions cannot currently be updated via ws message
                            },
                            orgId,
                            appId,
                            bucketId: bucket.id,
                        };

                        yield put(updateDistributionBucketSuccess(response));
                    }
                }

                break;
            }
            case ModelType.BuildDistroBuild: {
                for (const event of allModelTypeEvents) {
                    const build = event.data.model as BuildDistroBuild;

                    const response: FetchBuildDistributionBucketBuildResponsePayload = {
                        build,
                        orgId: event.data.orgId,
                        appId: event.data.appId!,
                    };

                    yield put(fetchBuildDistributionBucketBuildSuccess(response));
                }

                break;
            }
            case ModelType.RunwayModelsResponse: {
                for (const event of allModelTypeEvents) {
                    const runwayModels = event.data.model as RunwayModelsResponse;
                    yield spawn(updateRunwayModelsSaga, runwayModels);
                }

                break;
            }
            case ModelType.ReleaseStep: {
                const releaseSteps: ReleaseStep[] = [];
                for (const event of allModelTypeEvents) {
                    const releaseStep = event.data.model as ReleaseStep;
                    releaseSteps.push(releaseStep);
                }

                yield spawn(updateRunwayModelsSaga, {
                    releaseSteps,
                });

                break;
            }
            case ModelType.StepRun: {
                const stepRuns: StepRun[] = [];
                for (const event of allModelTypeEvents) {
                    const stepRun = event.data.model as StepRun;
                    stepRuns.push(stepRun);
                }

                yield spawn(updateRunwayModelsSaga, {
                    stepRuns,
                });

                break;
            }
            case ModelType.IosDependencies: {
                for (const event of allModelTypeEvents) {
                    const releaseId = event.data.releaseId;
                    const model = event.data.model as IosDependenciesUpdateMessage | undefined;
                    if (!releaseId || !model) {
                        continue;
                    }
                    const report: IosDependenciesReleaseReport = {
                        destinationId: model.destinationId,
                        destinationName: '',
                        status: model.status,
                        errorMessage: model.errorMessage,
                        report: model.status === 'success' ? model.report : undefined,
                        updatedAt: new Date().toISOString(),
                    };
                    yield put(updateIosDependenciesReportForRelease({ releaseId, report }));
                }
                break;
            }
        }
    }
}

interface IosDependenciesUpdateMessage {
    destinationId: string;
    version: unknown;
    status: import('@/types/iosDependencies').IosDependenciesStatus;
    errorMessage: string;
    report: import('@/types/iosDependencies').IosDependenciesReport;
}

export function selectPackageVersion() {
    return PACKAGE_VERSION;
}

export function* wsMessageSaga(action) {
    const payload = action.payload;
    const eventContainer: WebsocketEventContainer = JSON.parse(payload.message);

    const packageVersion = yield* call(selectPackageVersion);

    if (process.env.NODE_ENV !== Environment.Production) {
        console.log('Websocket message received with raw payload:');
        console.log(eventContainer);
    }

    // Display notfications first

    const notificationEvents = eventContainer.updates.filter(
        (event) => event.messageType === WebsocketMessageType.Notification,
    ) as WebsocketNotificationEvent[];

    if (notificationEvents.length > 0) {
        for (const event of notificationEvents) {
            const notification = event.data as Notification;

            yield put(newNotification(notification));
        }
    }

    // Updated state

    const stateUpdateEvents = eventContainer.updates.filter(
        (event) => event.messageType === WebsocketMessageType.StateUpdate,
    ) as WebsocketStateUpdateEvent[];

    const isAppsStateFetchedForApps = yield select(selectIsAppStateFetchedForApps);

    if (stateUpdateEvents.length > 0) {
        yield* call(handleStateUpdateEvents, stateUpdateEvents, isAppsStateFetchedForApps, packageVersion);
    }

    // New state

    const newStateEvents = eventContainer.updates.filter(
        (event) => event.messageType === WebsocketMessageType.NewState,
    ) as WebsocketNewStateEvent[];

    if (newStateEvents.length > 0) {
        for (const event of newStateEvents) {
            const payload = event.data as DashboardState;

            yield put(dashboardStateUpdatedFromWebsocket(payload));
        }
    }
}

export function* processAddedApps(
    response: CreateAppApiResponse[],
    orgId: string,
    orgIdParam: string,
    shouldRedirectToAddedApp = true,
) {
    const apps = response.map((apiResponse) => {
        return apiResponse.apps.map((app) => {
            return {
                orgId,
                orgIdParam,
                appGroupId: apiResponse.appGroup.id,
                app,
            };
        });
    });
    const connectedApps = flatten(apps);

    const connectedAppGroups = response.map((apiResponse) => {
        return {
            orgId,
            orgIdParam,
            appGroup: apiResponse.appGroup,
        };
    });

    const releases = response.map((apiResponse) => {
        return apiResponse.apps.map((app) => {
            return app.releases.map((release) => {
                return {
                    orgId,
                    orgIdParam,
                    appId: app.id,
                    appIdParam: app.appId,
                    release,
                };
            });
        });
    });

    const connectedReleases: ConnectedReleaseResponse[] = flattenDeep(releases);
    const connectedAppIdParams = connectedApps.map((connectedApp) => connectedApp.app.appId);

    yield put(appsAddedSuccess(connectedApps));
    yield put(appGroupsUpdated(connectedAppGroups));
    yield put(releasesUpdated(connectedReleases));

    if (shouldRedirectToAddedApp) {
        yield put(appsAddedShouldRedirect(connectedAppIdParams));
    }
}

export function* addAppsSaga(action: AddAppsAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const responseArray: CreateAppApiResponse[] = yield* call(API.addApps, action.payload, auth);
        const orgId = action.payload.orgId;
        const orgIdParam = action.payload.orgIdParam;

        yield* call(processAddedApps, responseArray, orgId, orgIdParam);

        yield spawn(updated, action.type);

        yield* call(trackAddAppEvent, orgId, responseArray);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

export function* createAppSaga(action: CreateAppAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response: CreateAppApiResponse[] = yield* call(API.createApp, action.payload, auth);
        const orgId = action.payload.orgId;
        const orgIdParam = action.payload.orgIdParam;

        yield* call(processAddedApps, response, orgId, orgIdParam);

        yield spawn(updated, action.type);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* setAutomationPauseSaga(action: TrySetAutomationPauseAction) {
    try {
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const auth = yield* call(getAuthCredentialsForSaga);
        const response: API.AutomationPauseState = yield* call(
            API.setAutomationPause,
            action.payload.requestData,
            auth,
        );

        yield put(
            setAutomationPauseSuccess({
                appId: action.payload.requestData.appId,
                allAutomationsPaused: response.allAutomationsPaused,
                pausedAutomationTypes: response.pausedAutomationTypes,
            }),
        );

        yield spawn(updated, action.type, action.payload.id);
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

export function* deleteAppSaga(action: TryDeleteAppAction) {
    yield put(clearFailure(action.type, action.payload.appId));
    yield put(loadingActionStart(action.type, action.payload.appId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.deleteApp, action.payload, auth);

        yield* call(willUpdate, action.type, action.payload.appId);

        const deleteAppPayload: DeletedAppEntityPayload = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            appGroupId: action.payload.appGroupId,
            orgIdParam: action.payload.orgIdParam,
        };

        yield spawn(updated, action.type, action.payload.appId);

        yield put(appsDeleted([deleteAppPayload]));
    } catch (error: any) {
        yield spawn(failure, action.type, error.message, action.payload.appId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.appId));
    }
}

const encodeSortInURL = (sortType: SortType, currentSearch: string, appId: string) => {
    const searchParams = new URLSearchParams(currentSearch);

    searchParams.set('sort', sortType);

    Storage.setFeatureItemsSortStoredParams(appId, sortType);

    return searchParams.toString();
};

// eslint-disable-next-line require-yield
export function* updateFeatureItemsSortSaga(action: UpdateFeatureItemsSortAction) {
    const url = new URL(window.location.toString());
    url.search = encodeSortInURL(action.payload.sortType, window.location.search, action.payload.appId);
    window.history.pushState({}, '', url.toString());
}

const encodeFiltersInURL = (filters: AnyFilter[], currentSearch: string, appId: string) => {
    const searchParams = new URLSearchParams(currentSearch);

    if (filters.length === 0) {
        searchParams.delete('filters');
        Storage.clearFeatureItemsFiltersStoredParams(appId);
        return searchParams.toString();
    }

    const filtersJSON = JSON.stringify(filters);
    searchParams.set('filters', filtersJSON);

    Storage.setFeatureItemsFiltersStoredParams(appId, filtersJSON);

    return searchParams.toString();
};

// eslint-disable-next-line require-yield
export function* updateFeatureItemsFiltersSaga(action: UpdateFeatureItemsFiltersAction) {
    const url = new URL(window.location.toString());
    url.search = encodeFiltersInURL(action.payload.filters, window.location.search, action.payload.appId);
    window.history.pushState({}, '', url.toString());
}

export function* removeFeatureItemsFilterSaga(action: RemoveFeatureItemsFilterAction) {
    const currentFiltersState: AnyFilter[] = yield select(selectAppliedFilters);
    const itemToBeRemoved = action.payload.filter;
    const newFilters = currentFiltersState?.filter((item) => !isEqual(item, itemToBeRemoved)) ?? [];
    const url = new URL(window.location.toString());
    url.search = encodeFiltersInURL(newFilters, window.location.search, action.payload.appId);
    window.history.pushState({}, '', url.toString());
}

const encodeShouldShowFixesOnlyInURL = (showFixesOnly: boolean, currentSearch: string, appId: string) => {
    const searchParams = new URLSearchParams(currentSearch);

    if (showFixesOnly) {
        searchParams.set('showFixesOnly', 'true');
        Storage.setFeatureItemsOnlyFixesStoredParams(appId, 'true');
    } else {
        searchParams.delete('showFixesOnly');
        Storage.clearFeatureItemsOnlyFixesStoredParams(appId);
    }

    return searchParams.toString();
};

// eslint-disable-next-line require-yield
export function* updateShowFixesOnlySaga(action: UpdateShowFixesOnlyAction) {
    const url = new URL(window.location.toString());
    url.search = encodeShouldShowFixesOnlyInURL(
        action.payload.showFixesOnly,
        window.location.search,
        action.payload.appId,
    );
    window.history.pushState({}, '', url.toString());
}

function* getAuthCredentialsForSaga() {
    let auth = yield select(selectAuthCredentials);

    if (auth) {
        // if auth credentials are expired fetch a new auth token
        if (isTokenRefreshDue(auth.expiry)) {
            yield* call(refreshToken, auth.token);
            auth = yield select(selectAuthCredentials);
        }
    }

    return auth;
}

const encodeGroupWorkItemsByTicketInURL = (groupByTicket: boolean, currentSearch: string, appId: string) => {
    const searchParams = new URLSearchParams(currentSearch);

    if (groupByTicket) {
        searchParams.set('groupWorkItemsByTicket', 'true');
        Storage.setFeatureItemsGroupByTicketStoredParams(appId, 'true');
    } else {
        searchParams.delete('groupWorkItemsByTicket');
        Storage.clearFeatureItemsGroupByTicketStoredParams(appId);
    }

    return searchParams.toString();
};

// eslint-disable-next-line require-yield
export function* updateGroupWorkItemsByTicketSaga(action: UpdateGroupWorkItemsByTicketAction) {
    const url = new URL(window.location.toString());
    url.search = encodeGroupWorkItemsByTicketInURL(
        action.payload.groupByTicket,
        window.location.search,
        action.payload.appId,
    );
    window.history.pushState({}, '', url.toString());
}

function* watchCreateNewRelease() {
    yield takeEvery(TRY_NEW_RELEASE, createReleaseSaga);
}

function* watchCreateNewBuildDistributionBucket() {
    yield takeEvery(TRY_NEW_BUILD_DISTRIBUTION_BUCKET, createBuildDistributionBucketSaga);
}

function* watchShareBuildDistributionBuildWithTesters() {
    yield takeEvery(UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS, shareBuildDistributionBuildWithTestersSaga);
}

function* watchUpdateBuildDistributionBuildTesterNotes() {
    yield takeEvery(UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES, updateBuildDistributionBuildTesterNotesSaga);
}

function* watchArchiveBuildDistributionBuild() {
    yield takeEvery(ARCHIVE_BUILD_DISTRIBUTION_BUILD, archiveBuildDistributionBuildSaga);
}

function* watchTriggerBuildDistributionBuild() {
    yield takeEvery(TRIGGER_BUILD_DISTRIBUTION_BUILD, triggerBuildDistributionBuildSaga);
}

function* watchTriggerReleaseWorkflowBuild() {
    yield takeEvery(TRIGGER_RELEASE_WORKFLOW_BUILD, triggerReleaseWorkflowBuildSaga);
}

function* watchArchiveBuildDistributionBucket() {
    yield takeEvery(TRY_ARCHIVE_BUILD_DISTRIBUTION_BUCKET, archiveBuildDistributionBucketSaga);
}

function* watchUpdateBuildDistributionBucket() {
    yield takeEvery(AllBuildDistroUpdatableTypes, updateBuildDistributionBucketSaga);
}

function* watchSignUp() {
    yield takeEvery(UserUpdatable.TRY_SIGN_UP, signUpSaga);
}

function* watchLoginRequest() {
    yield takeEvery(TRY_LOGIN, loginSaga);
}

function* watchRefreshToken() {
    yield all([takeEvery(TRY_REFRESH_AUTH_TOKEN, refreshToken), takeEvery(TRY_SILENT_REFRESH_TOKEN, refreshToken)]);
}

function* watchNewIntegration() {
    yield takeLeading(AllAuthUpdatableTypes, createIntegrationSaga);
}

function* watchUpdateIntegration() {
    yield takeEvery(AllIntegrationUpdatableTypes, updateIntegrationSaga);
}

function* watchUpdateIntegrationAlias() {
    yield takeEvery(TRY_UPDATE_INTEGRATION_ALIAS, updateIntegrationAliasSaga);
}

function* watchRefreshIntegration() {
    yield takeEvery(AllIntegrationRefreshableTypes, refreshIntegrationSaga);
}

function* watchDeleteIntegration() {
    yield takeEvery(AllIntegrationDeletableTypes, deleteIntegrationSaga);
}

function* watchUpdateDevices() {
    yield takeEvery(AllDevicesUpdatableTypes, updateDevicesSaga);
}

function* watchRefreshIntegrations() {
    yield takeEvery(TRY_REFRESH_INTEGRATIONS, refreshIntegrations);
}

function* watchDeleteRelease() {
    yield takeEvery(TRY_DELETE_RELEASE_ENTITY, deleteReleaseSaga);
}

function* watchUpdateRelease() {
    yield takeEvery(AllReleaseUpdatableTypes, updateReleaseSaga);
}

function* watchUpdateFeatureFlags() {
    yield takeEvery(AllFeatureFlagUpdatableTypes, updateFeatureFlagsSaga);
}

function* watchUpdateReleaseSteps() {
    yield takeEvery(AllReleaseStepUpdatableTypes, updateReleaseStepSaga);
}

function* watchUpdateChecklistItem() {
    yield takeEvery(AllChecklistItemUpdatableTypes, updateChecklistItemSaga);
}

function* watchUpdateAppSettings() {
    yield takeEvery(AllAppSettingsUpdatableTypes, updateAppSettingsSaga);
}

function* watchUpdateOrgSettings() {
    yield takeEvery(AllOrgSettingsUpdatableTypes, updateOrgSettingsSaga);
}

function* watchAddPublicApi() {
    yield takeEvery(AllPublicApiUpdatableTypes, addPublicApiSaga);
}

function* watchUpdateAppSettingsV2() {
    yield takeEvery(AllAppSettingsV2UpdatableTypes, updateAppSettingsV2Saga);
}

function* watchNewPassword() {
    yield takeEvery(UserUpdatable.TRY_NEW_PASSWORD, newPasswordSaga);
}

function* watchUpdateUserDevices() {
    yield takeEvery(UserUpdatable.UPDATE_USER_DEVICES, updateUserDevicesSaga);
}

function* watchUpdateUserShowSimplifiedBdUI() {
    yield takeEvery(UserUpdatable.UPDATE_SHOW_SIMPLIFIED_BD_UI, updateShouldShowSimplifiedBdUISaga);
}

function* watchVerifyCommsUser() {
    yield takeEvery(UserUpdatable.VERIFY_COMMS_USER, verifyCommsUserSaga);
}

function* watchLogout() {
    yield takeEvery(TRY_LOGOUT, logoutSaga);
}

function* watchUpdateReleaseEntity() {
    yield takeEvery(TRY_UPDATE_RELEASE_ENTITY, updateReleaseEntitySaga);
}

function* watchTryFetchState() {
    yield takeEvery([TRY_FETCH_STATE], fetchStateSaga);
}

function* watchSwitchOrgFetchState() {
    yield takeEvery([TRY_CHANGE_ORG_FETCH_STATE], switchOrgFetchState);
}

function* watchVerifyAuthCode() {
    yield takeEvery(TRY_VERIFY_AUTH_CODE, verifyAuthCodeSaga);
}

function* watchFetchEntity() {
    yield all([
        takeLatest(FetchableEntityType.AppState, fetchEntitySaga),
        takeLatest(FetchableEntityType.AppHome, fetchEntitySaga),
        takeLeading(FetchableEntityType.Release, fetchEntitySaga),
        takeLeading(FetchableEntityType.ReleaseStats, fetchEntitySaga),
        takeLeading(FetchableEntityType.GetReleaseOverview, fetchEntitySaga),
        takeLeading(FetchableEntityType.RolloutMonitoring, fetchEntitySaga),
        takeLeading(FetchableEntityType.FeatureFlags, fetchEntitySaga),
        takeLeading(FetchableEntityType.BuildDistributionBucketsWithRecentBuilds, fetchEntitySaga),
        takeLeading(FetchableEntityType.BuildDistributionBucket, fetchEntitySaga),
        takeLeading(FetchableEntityType.BuildDistributionBucketBuild, fetchEntitySaga),
        takeLeading(FetchableEntityType.ProvisioningProfiles, fetchEntitySaga),
        takeLeading(FetchableEntityType.BuildDistributionBucketDownloadMetrics, fetchEntitySaga),
        takeEvery(FetchableEntityType.ReleaseStep, fetchEntitySaga),
        takeEvery(FetchableEntityType.OrgOverviewV2, fetchEntitySaga), // spawns new saga for every request
        takeLeading(FetchableEntityType.OrgSummaryView, fetchEntitySaga),
        takeLeading(FetchableEntityType.OrgDestinationsAndVersions, fetchEntitySaga),
        takeEvery(FetchablePaginatedEntityType.Releases, fetchPaginatedEntitiesSaga),
        takeLatest(FetchablePaginatedEntityType.Issues, fetchPaginatedEntitiesSaga),
        takeEvery(TRY_CREATE_ISSUE, createIssueSaga),
        takeEvery(TRY_ADD_ISSUE_SOURCES, addIssueSourcesSaga),
        takeEvery(TRY_UNMERGE_ISSUE_SOURCES, unmergeIssueSourcesSaga),
        takeEvery(TRY_MARK_ISSUES_AS_RELATED, markIssuesAsRelatedSaga),
        takeEvery(TRY_UNMARK_ISSUE_AS_RELATED, unmarkIssueAsRelatedSaga),
        takeEvery(TRY_UPDATE_ISSUE, updateIssueSaga),
        takeEvery(TRY_UPDATE_ISSUE_ASSIGNEES, updateIssueAssigneesSaga),
        takeEvery(TRY_TRANSITION_ISSUE, transitionIssueSaga),
        takeEvery(TRY_BULK_TRANSITION_ISSUES, bulkTransitionIssuesSaga),
        takeEvery(TRY_BULK_REOPEN_ISSUES, bulkReopenIssuesSaga),
        takeEvery(TRY_GROUP_ISSUES, groupIssuesSaga),
        takeEvery(TRY_FETCH_ISSUE, fetchIssueSaga),
        takeLatest(TRY_FETCH_IOS_DEPENDENCIES_FOR_RELEASE, fetchIosDependenciesForReleaseSaga),
        takeEvery(TRY_REQUEST_ISSUE_FIX, requestIssueFixSaga),
        takeEvery(TRY_UPDATE_ISSUE_FIX_REQUEST, updateIssueFixRequestSaga),
        takeEvery(TRY_REOPEN_ISSUE, reopenIssueSaga),
        takeEvery(TRY_FETCH_ISSUE_TIMELINE, fetchIssueTimelineSaga),
        takeEvery(FetchablePaginatedEntityType.BuildDistributionBucketBuilds, fetchPaginatedEntitiesSaga),
        takeEvery(FetchablePaginatedEntityType.BuildDistributionSharedWithMeBuilds, fetchPaginatedEntitiesSaga),
        takeEvery(FetchablePaginatedEntityType.BuildDistributionBuildWorkItemsTimeline, fetchPaginatedEntitiesSaga),
        takeEvery(FetchablePaginatedEntityType.AllDevices, fetchPaginatedEntitiesSaga),
    ]);
}

function* watchFetchEntityV2() {
    yield all([
        yield takeLatest(FetchableEntityTypeV2.StepRun, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.StepRunsSummary, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.StepConfig, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.WorkflowOverview, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.OrgChecklistItemTemplates, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.OrgUsersVCSUserData, fetchEntityV2Saga),
    ]);
}

function* watchRunwayUpdatable() {
    const effects = AllRunwayUpdatables.map((updatable) => {
        if (hasSupportForParallelism(updatable)) {
            return takeEvery(updatable, runwayUpdatableSaga);
        } else {
            return takeLatest(updatable, runwayUpdatableSaga);
        }
    });

    yield all(effects);
}

function* watchAddApps() {
    yield takeLeading(TRY_ADD_APPS, addAppsSaga);
}

function* watchCreateApp() {
    yield takeLeading(TRY_CREATE_APP, createAppSaga);
}

function* watchDeleteApp() {
    yield takeEvery(TRY_DELETE_APP_ENTITY, deleteAppSaga);
}

function* watchUpdateApp() {
    yield takeEvery(AllAppUpdatableTypes, setAutomationPauseSaga);
}

function* watchUpdateUserflowUser() {
    yield takeEvery(
        [NEW_RELEASE_SUCCESS, APPS_ADDED_SUCCESS, CREATE_INTEGRATION_REQUEST_SUCCESS, UPDATE_ORG_SETTINGS_SUCCESS],
        updateUserflowUser,
    );
}

function* watchGetAppConfig() {
    yield takeEvery([TRY_GET_APP_CONFIG, TRY_SILENT_GET_APP_CONFIG], getAppConfigSaga);
}

function* watchTrackingEvents() {
    yield all([
        takeLeading(TRACK_ORG_ROUTE_EVENT, trackOrgRouteEventSaga),
        takeLeading(TRACK_APP_ROUTE_EVENT, trackAppRouteEventSaga),
        takeLeading(TRACK_RELEASE_ROUTE_EVENT, trackReleaseRouteEventSaga),
        takeLeading(TRACK_BUILD_DISTRO_EVENT, trackBuildDistroEventSaga),
        takeLeading(TRACK_RELEASE_STEP_VIEW_EVENT, trackViewReleaseStepEventSaga),
        takeLeading(TRACK_USER_EVENT, trackUserEventSaga),
        takeLeading(TRACK_ONBOARDING_EVENT, trackOnboardingEventSaga),
        takeLeading(TRACK_STEP_CONFIG_EVENT, trackStepConfigEventSaga),
    ]);
}

function* watchFRItemsURLParams() {
    yield takeEvery(UPDATE_FEATURE_ITEMS_SORT, updateFeatureItemsSortSaga);
    yield takeEvery(UPDATE_FEATURE_ITEMS_FILTERS, updateFeatureItemsFiltersSaga);
    yield takeEvery(REMOVE_FEATURE_ITEMS_FILTER, removeFeatureItemsFilterSaga);
    yield takeEvery(UPDATE_SHOW_FIXES_ONLY, updateShowFixesOnlySaga);
    yield takeEvery(UPDATE_GROUP_WORK_ITEMS_BY_TICKET, updateGroupWorkItemsByTicketSaga);
}

export function* rootSaga() {
    yield all([
        watchGetAppConfig(),
        watchLoginRequest(),
        watchRefreshToken(),
        watchUpdateUserflowUser(),
        WsEffects.watchWebsocketConnect(),
        WsEffects.watchWebsocketError(),
        WsEffects.watchWebsocketReconnect(),
        WsEffects.watchWebsocketOpen(),
        WsEffects.watchWebsocketClosed(),
        WsEffects.watchWebsocketMessage(),
        WsEffects.watchLogoutSuccess(),
        watchUpdateRelease(),
        watchUpdateFeatureFlags(),
        watchUpdateReleaseSteps(),
        watchUpdateChecklistItem(),
        watchUpdateAppSettings(),
        watchUpdateAppSettingsV2(),
        watchUpdateOrgSettings(),
        watchAddPublicApi(),
        watchNewIntegration(),
        watchUpdateIntegration(),
        watchUpdateIntegrationAlias(),
        watchRefreshIntegration(),
        watchUpdateDevices(),
        watchDeleteIntegration(),
        watchNewPassword(),
        watchUpdateUserDevices(),
        watchUpdateUserShowSimplifiedBdUI(),
        watchVerifyCommsUser(),
        watchCreateNewRelease(),
        watchCreateNewBuildDistributionBucket(),
        watchUpdateBuildDistributionBuildTesterNotes(),
        watchArchiveBuildDistributionBuild(),
        watchTriggerBuildDistributionBuild(),
        watchArchiveBuildDistributionBucket(),
        watchUpdateBuildDistributionBucket(),
        watchShareBuildDistributionBuildWithTesters(),
        watchLogout(),
        watchRefreshIntegrations(),
        watchUpdateReleaseEntity(),
        watchDeleteRelease(),
        watchTryFetchState(),
        watchVerifyAuthCode(),
        watchFetchEntity(),
        watchFetchEntityV2(),
        watchRunwayUpdatable(),
        watchAddApps(),
        watchCreateApp(),
        watchDeleteApp(),
        watchUpdateApp(),
        watchSignUp(),
        watchSwitchOrgFetchState(),
        watchFRItemsURLParams(),
        watchTrackingEvents(),
        watchTriggerReleaseWorkflowBuild(),
    ]);
}
